(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6573],{

/***/ 42872:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/content/community/list",
      function () {
        return __webpack_require__(84670);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 13971:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ atom_Skeleton; }
});

// EXTERNAL MODULE: ../../node_modules/next/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(62230);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/next/node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(75190);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(89961);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(44376);
// EXTERNAL MODULE: ./src/utils/opacity.ts + 1 modules
var opacity = __webpack_require__(52172);
;// CONCATENATED MODULE: ./src/components/atom/Skeleton/styles.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  to {\n    background-position-x: -20%;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: 5px;\n  ",
        "\n  background-size: 200% 100%;\n  background-position-x: 180%;\n  animation: 1.6s ",
        " ease-in-out infinite;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var loading = (0,styled_components_browser_esm/* keyframes */.F4)(_templateObject());
var StyledSkeleton = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a4c00a2-0"
})(_templateObject1(), function(param) {
    var _backgroundColor = param.backgroundColor, backgroundColor = _backgroundColor === void 0 ? theme/* default.color.gray40 */.Z.color.gray40 : _backgroundColor, _gradientColor = param.gradientColor, gradientColor = _gradientColor === void 0 ? "#ffffff" : _gradientColor;
    return "\n    background-color: ".concat(backgroundColor, ";\n    background: linear-gradient(\n        120deg,\n        ").concat((0,opacity/* withOpacity */.C)(gradientColor, "0%"), " 40%,\n        ").concat((0,opacity/* withOpacity */.C)(gradientColor, "50%"), " 50%,\n        ").concat((0,opacity/* withOpacity */.C)(gradientColor, "0%"), " 60%\n      )\n      ").concat(backgroundColor, ";\n  ");
}, loading);

;// CONCATENATED MODULE: ./src/components/atom/Skeleton/index.tsx



var Skeleton = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSkeleton, (0,_object_spread/* default */.Z)({}, props));
};
/* harmony default export */ var atom_Skeleton = (Skeleton);


/***/ }),

/***/ 91707:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(62230);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85244);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98240);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(75190);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(89961);
/* harmony import */ var _DefaultButton__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47641);




function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: sticky;\n  bottom: 0;\n  left: 0;\n  margin: 0 auto;\n  width: 100%;\n  z-index: 50;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  margin: 0 auto;\n  padding: 0 20px 16px;\n\n  div + div {\n    margin-left: 10px;\n  }\n\n  ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: 32px;\n  width: 100%;\n\n  right: 0;\n  top: -32px;\n  background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #ffffff 100%);\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  flex: 7;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  border-radius: 12px;\n  padding: 17px;\n  height: 60px;\n\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        ";\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  flex: 3;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}



var StickyButton = function(_param) {
    var children = _param.children, _hasGradient = _param.hasGradient, hasGradient = _hasGradient === void 0 ? true : _hasGradient, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "children",
        "hasGradient"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StickyButtonContainer, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        id: "stickyButton"
    }, props), {
        children: [
            hasGradient && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StickyButtonWrapperGradient, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StickyButtonWrapper, {
                children: children
            })
        ]
    }));
};
var Button = function(_param) /*#__PURE__*/ {
    var text = _param.text, buttonProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "text"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ButtonWrapper, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledButton, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, buttonProps), {
            children: text
        }))
    });
};
var SubButton = function(_param) /*#__PURE__*/ {
    var text = _param.text, buttonProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "text"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(SubButtonWrapper, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledSubButton, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, buttonProps), {
            children: text
        }))
    });
};
var WhiteSubButton = function(_param) /*#__PURE__*/ {
    var text = _param.text, buttonProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "text"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(SubButtonWrapper, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledWhiteSubButton, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, buttonProps), {
            children: text
        }))
    });
};
StickyButton.Button = Button;
StickyButton.SubButton = SubButton;
StickyButton.WhiteSubButton = WhiteSubButton;
/* harmony default export */ __webpack_exports__["Z"] = (StickyButton);
var StickyButtonContainer = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-8516f78f-0"
})(_templateObject());
var StickyButtonWrapper = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-8516f78f-1"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return "\n    max-width: ".concat(theme.size.tablet, ";\n    background-color: ").concat(theme.color.white, ";\n  ");
});
var StickyButtonWrapperGradient = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-8516f78f-2"
})(_templateObject2());
var ButtonWrapper = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-8516f78f-3"
})(_templateObject3());
var StyledDefaultButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(_DefaultButton__WEBPACK_IMPORTED_MODULE_2__/* .DefaultButtonStyled */ .qY).withConfig({
    componentId: "sc-8516f78f-4"
})(_templateObject4(), function(param) {
    var theme = param.theme;
    return "\n    ".concat(theme.typography.UI18SB, ";\n    background: ").concat(theme.color.primary600, ";\n    color: ").concat(theme.color.white, ";\n  \n    &:disabled {\n      background: ").concat(theme.color.gray200, ";\n    }\n  ");
});
var StyledButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(StyledDefaultButton).withConfig({
    componentId: "sc-8516f78f-5"
})(_templateObject5(), function(param) {
    var theme = param.theme;
    return "\n    background: ".concat(theme.color.primary600, ";\n    &: active:not(:disabled) {\n      background: ").concat(theme.color.primary700, ";\n    }\n  ");
});
var SubButtonWrapper = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-8516f78f-6"
})(_templateObject6());
var StyledSubButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(StyledDefaultButton).withConfig({
    componentId: "sc-8516f78f-7"
})(_templateObject7(), function(param) {
    var theme = param.theme;
    return "\n    background: ".concat(theme.color.gray700, ";\n    &: active {\n      background: ").concat(theme.color.gray800, ";\n    }\n  ");
});
var StyledWhiteSubButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(StyledDefaultButton).withConfig({
    componentId: "sc-8516f78f-8"
})(_templateObject8(), function(param) {
    var theme = param.theme;
    return "\n    background: ".concat(theme.color.white, ";\n    color: ").concat(theme.color.gray600, ";\n    border: 1px solid ").concat(theme.color.gray100, ";\n    \n    &: active {\n      background: ").concat(theme.color.white, ";\n    }\n  ");
});


/***/ }),

/***/ 70508:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Arrow_Arrow; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./src/types/common.ts
var common = __webpack_require__(70138);
// EXTERNAL MODULE: ../../node_modules/next/node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(75190);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(89961);
;// CONCATENATED MODULE: ./src/components/atom/icon/Arrow/styles.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  transition: transform 0.1s linear;\n  transform: rotate(\n    ",
        "deg\n  );\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var ArrowSVG = styled_components_browser_esm/* default.svg.withConfig */.ZP.svg.withConfig({
    componentId: "sc-6c242133-0"
})(_templateObject(), function(param) {
    var direction = param.direction;
    return direction === common/* DIRECTION.TOP */.JR.TOP ? 90 : direction === common/* DIRECTION.BOTTOM */.JR.BOTTOM ? -90 : direction === common/* DIRECTION.LEFT */.JR.LEFT ? 180 : 0;
});

;// CONCATENATED MODULE: ./src/components/atom/icon/Arrow/Arrow.tsx




var Arrow = function(param) {
    var _size = param.size, size = _size === void 0 ? 20 : _size, _direction = param.direction, direction = _direction === void 0 ? common/* DIRECTION.RIGHT */.JR.RIGHT : _direction, _fill = param.fill, fill = _fill === void 0 ? "#71767A" : _fill;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowSVG, {
        direction: direction,
        width: size,
        height: size,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M6.94723 3.34139C6.79298 3.37016 6.65153 3.46421 6.56349 3.59654C6.50157 3.6896 6.47584 3.77119 6.47142 3.88853C6.46597 4.03351 6.49103 4.12869 6.56462 4.24248C6.58365 4.2719 7.19476 4.88598 9.44798 7.13982L12.3072 9.99982L9.44798 12.8598C7.19476 15.1137 6.58365 15.7277 6.56462 15.7572C6.49103 15.8709 6.46597 15.9661 6.47142 16.1111C6.47468 16.1974 6.48713 16.2542 6.51781 16.3224C6.58073 16.4623 6.7185 16.5875 6.86388 16.6369C6.99749 16.6824 7.17399 16.6736 7.29639 16.6155C7.40291 16.5649 7.19523 16.769 10.3504 13.6138C12.0337 11.9305 13.2888 10.6713 13.3094 10.6452C13.5554 10.3338 13.6034 9.91058 13.4331 9.55448C13.3984 9.48186 13.3562 9.41373 13.3094 9.35449C13.2888 9.32838 12.0337 8.06916 10.3504 6.38588C7.79324 3.82863 7.42154 3.45889 7.38176 3.43286C7.27641 3.3639 7.19515 3.33851 7.0699 3.33541C7.01397 3.33402 6.97706 3.33582 6.94723 3.34139Z",
            fill: fill
        })
    });
};
/* harmony default export */ var Arrow_Arrow = (Arrow);


/***/ }),

/***/ 83384:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);

var HandHeldTabletWriting = function(param) {
    var _width = param.width, width = _width === void 0 ? 16 : _width, _height = param.height, height = _height === void 0 ? 16 : _height;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                clipPath: "url(#clip0_2196_36519)",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M2.13352 0.107143C1.05471 0.107143 0.231934 1.00462 0.231934 2.04671V13.9533C0.231934 14.9954 1.05471 15.8928 2.13352 15.8928H11.5335C12.6124 15.8928 13.4351 14.9954 13.4351 13.9533V2.10714C13.4351 1.00257 12.5397 0.107143 11.4351 0.107143H2.13352Z",
                        fill: "#DFE1E2"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M1.08912 11.7143H0.231934L0.231972 12.5714L0.232034 13.9533C0.232055 14.9953 1.05482 15.8928 2.13362 15.8928H11.5336C12.6125 15.8928 13.4352 14.9954 13.4352 13.9533L13.4351 12.5714V11.7143H12.578H1.08912Z",
                        fill: "#2F9E44"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M3.23186 3.4368C2.83738 3.4368 2.51758 3.7566 2.51758 4.15109C2.51758 4.54558 2.83738 4.86537 3.23186 4.86537H6.08362C6.47812 4.86537 6.79791 4.54558 6.79791 4.15109C6.79791 3.7566 6.47812 3.4368 6.08362 3.4368H3.23186ZM3.23186 6.71429C2.83738 6.71429 2.51758 7.03408 2.51758 7.42857C2.51758 7.82306 2.83738 8.14286 3.23186 8.14286H4.65775C5.05224 8.14286 5.37204 7.82306 5.37204 7.42857C5.37204 7.03408 5.05224 6.71429 4.65775 6.71429H3.23186Z",
                        fill: "#2F9E44"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M10.7449 8.45062C10.6623 8.53358 10.5563 8.58918 10.4411 8.60991L7.98586 9.05184C7.59741 9.12176 7.25672 8.78618 7.32078 8.39672L7.73093 5.90301C7.7504 5.78462 7.80664 5.67537 7.89168 5.59073L12.5951 0.909485C12.7014 0.802367 12.8278 0.717346 12.967 0.659324C13.1063 0.601302 13.2557 0.57143 13.4066 0.57143C13.5574 0.57143 13.7068 0.601302 13.8461 0.659324C13.9854 0.717346 14.1118 0.802367 14.218 0.909485L15.4294 2.12092C15.5365 2.22716 15.6215 2.35356 15.6796 2.49282C15.7377 2.63209 15.7675 2.78148 15.7675 2.93234C15.7675 3.08321 15.7377 3.2326 15.6796 3.37185C15.6215 3.51112 15.5365 3.63753 15.4294 3.74377L10.7449 8.45062Z",
                        fill: "#2F9E44"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                    id: "clip0_2196_36519",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        width: "16",
                        height: "16",
                        fill: "white"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (HandHeldTabletWriting);


/***/ }),

/***/ 23773:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);


var ValidationCheck = function(param) {
    var _size = param.size, size = _size === void 0 ? 22 : _size, _fill = param.fill, fill = _fill === void 0 ? "#FD7E14" : _fill;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 22 22",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M17.6177 4.08603C17.308 4.10941 17.0333 4.23068 16.8203 4.43801C16.7884 4.46904 16.6991 4.57074 16.6217 4.66402C16.5444 4.7573 14.562 7.15634 12.2165 9.99522C9.87092 12.8341 7.94719 15.1617 7.94154 15.1677C7.93199 15.1779 7.83829 15.0591 6.61926 13.4912C5.89766 12.5631 5.28336 11.7758 5.25414 11.7416C5.04815 11.5005 4.76686 11.3561 4.42726 11.3171C4.03981 11.2727 3.67174 11.4012 3.385 11.681C3.26909 11.7941 3.18925 11.9037 3.1252 12.0379C3.03536 12.226 2.99499 12.428 3.002 12.6544C3.01031 12.9231 3.08506 13.1368 3.24943 13.3616C3.29208 13.42 6.06564 16.9865 6.13862 17.0768C6.20396 17.1577 6.35713 17.3121 6.4381 17.3787C7.01938 17.8566 7.7708 18.0264 8.49981 17.8445C8.94568 17.7333 9.36276 17.4771 9.67163 17.1248C9.72674 17.062 18.6401 6.27711 18.7207 6.17582C18.859 6.00194 18.9475 5.80736 18.9848 5.59522C19.0002 5.50737 19.0033 5.32047 18.9909 5.21907C18.9532 4.91081 18.8316 4.66495 18.612 4.4526C18.337 4.18674 17.988 4.05808 17.6177 4.08603Z",
            fill: fill
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ValidationCheck);


/***/ }),

/***/ 80230:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(75190);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(89961);
/* harmony import */ var _components_atom_buttons_DefaultButton__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47641);
/* harmony import */ var _components_atom_icon_checkBox_RadioIcon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(27683);
/* harmony import */ var _components_molecules_BottomSheet__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(39535);
/* harmony import */ var _hooks_community_mobile_community_gql_impl__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(42549);
/* harmony import */ var _services_community__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(29178);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 24px 0 8px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 0 24px 8px;\n  ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 12px 24px;\n  width: 100%;\n  justify-content: flex-start;\n\n  svg {\n    margin-right: 12px;\n  }\n\n  ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}







var CommunityCategoryBottomSheet = function(param) {
    var isOpened = param.isOpened, selectedCategoryId = param.selectedCategoryId, onClickCategory = param.onClickCategory, onClose = param.onClose, isFilter = param.isFilter, onClickAllCategory = param.onClickAllCategory;
    var ref = (0,_hooks_community_mobile_community_gql_impl__WEBPACK_IMPORTED_MODULE_5__/* .useGetBoardCategoriesQuery */ .hw)({}, {
        select: function(data) {
            return (0,_services_community__WEBPACK_IMPORTED_MODULE_6__/* .boardCategoriesService */ .Z6)(data);
        }
    }), categories = ref.data;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_molecules_BottomSheet__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, {
        index: 10,
        isOpened: isOpened,
        onClickOverlay: onClose,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Wrapper, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Title, {
                    children: "카테고리 선택"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(CategoryWrapper, {
                    children: [
                        isFilter && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Category, {
                            onClick: onClickAllCategory,
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_atom_icon_checkBox_RadioIcon__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                    isSelected: !selectedCategoryId
                                }),
                                "전체"
                            ]
                        }),
                        categories === null || categories === void 0 ? void 0 : categories.map(function(category, key) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Category, {
                                onClick: function() {
                                    return onClickCategory(category);
                                },
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_atom_icon_checkBox_RadioIcon__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                        isSelected: category.boardCategoryId === selectedCategoryId
                                    }),
                                    category.name
                                ]
                            }, "category_".concat(key));
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CommunityCategoryBottomSheet);
var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-fba8288d-0"
})(_templateObject());
var Title = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-fba8288d-1"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return "\n    ".concat(theme.typography.UI20SB, ";\n    color: ").concat(theme.color.gray700, ";\n  ");
});
var CategoryWrapper = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-fba8288d-2"
})(_templateObject2());
var Category = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)(_components_atom_buttons_DefaultButton__WEBPACK_IMPORTED_MODULE_2__/* .DefaultButtonStyled */ .qY).withConfig({
    componentId: "sc-fba8288d-3"
})(_templateObject3(), function(param) {
    var theme = param.theme;
    return "\n    ".concat(theme.typography.UI16M, ";\n    color: ").concat(theme.color.gray500, ";\n\n    &: active {\n      background: ").concat(theme.color.gray50, ";\n    }\n  ");
});


/***/ }),

/***/ 53086:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export InfiniteScrollContainer */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(75190);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(89961);
/* harmony import */ var _components_molecules_Loader__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6505);
/* harmony import */ var _hooks_useIntersectionObserver__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(13041);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  overflow-y: scroll;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var InfiniteScroll = function(param) {
    var _threshold = param.threshold, threshold = _threshold === void 0 ? 0 : _threshold, rootMargin = param.rootMargin, children = param.children, _loader = param.loader, loader = _loader === void 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_molecules_Loader__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {}) : _loader, isLoading = param.isLoading, hasNextPage = param.hasNextPage, fetchNextPage = param.fetchNextPage;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(), loaderElement = ref[0], setLoaderElement = ref[1];
    var entry = (0,_hooks_useIntersectionObserver__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        target: loaderElement,
        threshold: threshold,
        rootMargin: rootMargin
    });
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if ((entry === null || entry === void 0 ? void 0 : entry.isIntersecting) && hasNextPage && !isLoading) {
            fetchNextPage();
        }
    }, [
        entry,
        hasNextPage,
        isLoading,
        fetchNextPage
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(InfiniteScrollContainer, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                children: children
            }),
            hasNextPage && !isLoading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                ref: function(ref) {
                    return setLoaderElement(ref);
                },
                children: loader
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (InfiniteScroll);
var InfiniteScrollContainer = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].section.withConfig */ .ZP.section.withConfig({
    componentId: "sc-360f8560-0"
})(_templateObject());


/***/ }),

/***/ 22909:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(62230);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85244);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98240);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(75190);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);
/* harmony import */ var react_simple_pull_to_refresh__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52560);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(89961);
/* eslint-disable @typescript-eslint/no-explicit-any */ 



function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var PullToRefreshContainer = function(_param) {
    var children = _param.children, _pullingContent = _param.pullingContent, pullingContent = _pullingContent === void 0 ? "" : _pullingContent, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "children",
        "pullingContent"
    ]);
    var _maxPullDownDistance, _maxPullDownDistance1;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledPullToRefresh, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, props), {
        pullingContent: pullingContent,
        maxPullDownDistance: (_maxPullDownDistance = props.maxPullDownDistance) !== null && _maxPullDownDistance !== void 0 ? _maxPullDownDistance : 70,
        bottomPadding: (_maxPullDownDistance1 = props.maxPullDownDistance) !== null && _maxPullDownDistance1 !== void 0 ? _maxPullDownDistance1 : 70,
        children: children
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (PullToRefreshContainer);
var StyledPullToRefresh = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(react_simple_pull_to_refresh__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-690ab5c4-0"
})(_templateObject(), function(param) {
    var theme = param.theme, bottomPadding = param.bottomPadding;
    return "\n    padding-bottom: ".concat(bottomPadding, "px;\n    .lds-ellipsis {\n      width: 60px;\n      height: 60px;\n    }\n    \n    .lds-ellipsis div {\n      background: ").concat(theme.color.primary500, ";\n      width: 8px;\n      height: 8px;\n    }\n\n    .ptr__pull-down {\n      opacity: 0;\n    }\n    .ptr__loader {\n      display: none;\n    }\n  ");
});


/***/ }),

/***/ 79771:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ molecules_ScrollTopStickyButton; }
});

// EXTERNAL MODULE: ../../node_modules/next/node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(75190);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(89961);
// EXTERNAL MODULE: ./src/components/atom/buttons/DefaultButton.tsx
var DefaultButton = __webpack_require__(47641);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(44376);
// EXTERNAL MODULE: ./src/types/common.ts
var common = __webpack_require__(70138);
;// CONCATENATED MODULE: ./src/components/atom/icon/Arrow/ArrowInCircle.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  transition: transform 0.1s linear;\n  transform: rotate(\n    ",
        "deg\n  );\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var ArrowInCircle = function(param) {
    var _direction = param.direction, direction = _direction === void 0 ? common/* DIRECTION.RIGHT */.JR.RIGHT : _direction, _size = param.size, size = _size === void 0 ? 16 : _size, _color = param.color, color = _color === void 0 ? theme/* default.color.white */.Z.color.white : _color;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ArrowInCircleSVG, {
        direction: direction,
        width: size,
        height: size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                clipPath: "url(#clip0_1728_38508)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M7.71199 0.00365558C7.40199 0.0174604 7.16633 0.0378636 6.89919 0.0740236C5.8055 0.222068 4.72382 0.613396 3.77279 1.20511C2.68739 1.88042 1.75155 2.83904 1.1038 3.9391C0.969715 4.16681 0.78807 4.52047 0.684986 4.75454C0.31984 5.58364 0.105338 6.4179 0.029088 7.3055C0.00733441 7.55872 0.00336641 7.66559 0.00330881 7.9999C0.00323841 8.38025 0.012736 8.56881 0.048256 8.8927C0.176986 10.0664 0.575565 11.2151 1.2052 12.2271C1.70536 13.031 2.36305 13.7564 3.12639 14.3461C3.81718 14.8798 4.61871 15.3064 5.46239 15.5894C6.06347 15.791 6.66767 15.916 7.30559 15.9708C7.56083 15.9927 7.66525 15.9966 7.99999 15.9966C8.38048 15.9966 8.5695 15.9871 8.89279 15.9516C10.0664 15.8229 11.2153 15.4243 12.2272 14.7947C12.6163 14.5526 12.9777 14.2806 13.3504 13.9494C13.462 13.8501 13.8502 13.4619 13.9494 13.3503C14.4614 12.7742 14.8403 12.216 15.1679 11.5551C15.6134 10.6564 15.8774 9.72425 15.9682 8.73007C15.9798 8.60248 15.9935 8.37651 15.9936 8.31228C15.9936 8.27786 15.9964 8.24849 16 8.2463C16.0041 8.24377 16.0064 8.15343 16.0064 7.99632C16.0064 7.83657 16.0041 7.7503 16 7.7503C15.9962 7.7503 15.9936 7.72522 15.9936 7.6879C15.9935 7.58302 15.9738 7.30899 15.9517 7.1071C15.8235 5.93502 15.4243 4.78451 14.7948 3.7727C14.5051 3.30711 14.1701 2.8765 13.7864 2.4767C13.118 1.78016 12.3994 1.25039 11.5552 0.831963C10.59 0.353537 9.6183 0.0922316 8.51874 0.0153804C8.39084 0.00644598 7.83183 -0.00168202 7.71199 0.00365558ZM7.87199 1.40599C6.51278 1.42618 5.16218 1.88736 4.06399 2.70629C3.55807 3.08356 3.08446 3.55715 2.70634 4.0639C2.28567 4.62765 1.95731 5.26075 1.73208 5.9423C1.55219 6.4867 1.44975 7.03306 1.41411 7.6383C1.4049 7.79487 1.4049 8.20493 1.41411 8.3615C1.45084 8.98511 1.55818 9.54453 1.74937 10.1087C2.13642 11.2508 2.8074 12.2385 3.73439 13.0307C4.75758 13.9051 6.06682 14.4534 7.40799 14.5692C7.78637 14.6019 8.2136 14.6019 8.59199 14.5692C9.93328 14.4534 11.2413 13.9056 12.2656 13.0307C12.5331 12.8022 12.8023 12.533 13.0307 12.2655C13.8517 11.3044 14.3852 10.0943 14.5433 8.8351C14.6005 8.37976 14.6094 7.886 14.5691 7.4079C14.4623 6.14101 13.9559 4.87986 13.1538 3.88332C12.8906 3.55628 12.587 3.24375 12.2656 2.96911C11.3046 2.14789 10.0901 1.61279 8.83199 1.45631C8.52785 1.41848 8.19735 1.40116 7.87199 1.40599ZM7.91999 5.05669C7.80378 5.06771 7.68763 5.11258 7.58967 5.18431C7.50807 5.24407 4.09794 8.65663 4.05223 8.72428C4.00618 8.79243 3.97108 8.86842 3.9508 8.9439C3.93508 9.00232 3.9336 9.01794 3.93373 9.1231C3.93386 9.22723 3.93551 9.2444 3.95085 9.30184C3.99114 9.45262 4.08821 9.59317 4.22079 9.69266C4.27789 9.73551 4.37846 9.7836 4.45119 9.80282C4.50818 9.81788 4.52745 9.81978 4.62719 9.82022C4.75531 9.82077 4.80218 9.81264 4.89905 9.77308C5.03337 9.71821 4.92938 9.81739 6.53599 8.21185L8 6.74883L9.46399 8.21187C11.0707 9.8175 10.9666 9.7182 11.1009 9.77308C11.1978 9.81264 11.2447 9.82077 11.3728 9.82022C11.4725 9.81978 11.4918 9.81788 11.5488 9.80282C11.6994 9.76302 11.8368 9.66766 11.9373 9.53325C12.0326 9.4057 12.0767 9.25483 12.0684 9.08508C12.0619 8.95062 12.0238 8.83684 11.9477 8.72428C11.902 8.65663 8.4919 5.24407 8.4103 5.18431C8.30816 5.10952 8.19884 5.06847 8.06959 5.05636C8.02955 5.05261 7.99247 5.04992 7.98719 5.05039C7.98191 5.05085 7.95167 5.05368 7.91999 5.05669ZM0.00289921 8.0031C0.00289921 8.14038 0.00374401 8.19563 0.00478081 8.12588C0.00581761 8.05612 0.00581121 7.9438 0.00477441 7.87628C0.00374401 7.80875 0.00289281 7.86582 0.00289921 8.0031Z",
                    fill: color
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_1728_38508",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "16",
                        height: "16",
                        fill: color
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var Arrow_ArrowInCircle = (ArrowInCircle);
var ArrowInCircleSVG = styled_components_browser_esm/* default.svg.withConfig */.ZP.svg.withConfig({
    componentId: "sc-206086a2-0"
})(_templateObject(), function(param) {
    var direction = param.direction;
    return direction === common/* DIRECTION.TOP */.JR.TOP ? 0 : direction === common/* DIRECTION.BOTTOM */.JR.BOTTOM ? 180 : direction === common/* DIRECTION.LEFT */.JR.LEFT ? -90 : 90;
});

;// CONCATENATED MODULE: ./src/components/molecules/ScrollTopStickyButton/index.tsx

function ScrollTopStickyButton_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: fixed;\n  margin: 0 auto;\n  left: 50%;\n  visibility: ",
        ";\n  opacity: ",
        ";\n  transform: translate(-50%, -50%);\n  top: calc(",
        " + 28px);\n  transition: all 0.5s ease-out;\n"
    ]);
    ScrollTopStickyButton_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 156px;\n  height: 32px;\n  border-radius: 16px;\n  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.16);\n\n  ",
        "\n\n  svg {\n    margin-left: 8px;\n  }\n\n  &:active {\n    background: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






var ScrollTopStickyButton = function(param) {
    var minY = param.minY;
    var ref = (0,react.useState)(false), isVisible = ref[0], setIsVisible = ref[1];
    var ref1 = (0,react.useState)(0), lastScrollY = ref1[0], setLastScrollY = ref1[1];
    var ref2 = (0,react.useState)(0), innerHeight = ref2[0], setInnerHeight = ref2[1];
    var onScroll = function() {
        var scrollY = window.scrollY;
        if (window.scrollY <= innerHeight) {
            return setIsVisible(false);
        }
        scrollY > lastScrollY ? setIsVisible(false) : setIsVisible(true);
        setLastScrollY(scrollY);
    };
    var onScrollTop = function() {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    };
    (0,react.useLayoutEffect)(function() {
        window.addEventListener("scroll", onScroll);
        return function() {
            return window.removeEventListener("scroll", onScroll);
        };
    });
    (0,react.useEffect)(function() {
        if (!minY) {
            setInnerHeight(window.innerHeight * 2);
        }
    }, [
        minY
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollTopStickyButtonContainer, {
        isVisible: isVisible,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ScrollTopStickyButtonWrapper, {
            onClick: onScrollTop,
            children: [
                "상단으로 가기 ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Arrow_ArrowInCircle, {
                    direction: common/* DIRECTION.TOP */.JR.TOP
                })
            ]
        })
    });
};
/* harmony default export */ var molecules_ScrollTopStickyButton = (ScrollTopStickyButton);
var ScrollTopStickyButtonContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2d53a0b1-0"
})(ScrollTopStickyButton_templateObject(), function(param) {
    var isVisible = param.isVisible;
    return !isVisible && "hidden";
}, function(param) {
    var isVisible = param.isVisible;
    return !isVisible && 0;
}, function(param) {
    var theme = param.theme;
    return theme.size.appHeader.height;
});
var ScrollTopStickyButtonWrapper = (0,styled_components_browser_esm/* default */.ZP)(DefaultButton/* DefaultButtonStyled */.qY).withConfig({
    componentId: "sc-2d53a0b1-1"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return "\n    ".concat(theme.typography.UI14SB, ";\n    color: ").concat(theme.color.white, ";\n    background: ").concat(theme.color.gray800, ";\n  ");
}, function(param) {
    var theme = param.theme;
    return theme.color.gray700;
});


/***/ }),

/***/ 71213:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);
/* harmony import */ var _components_molecules_LoginModal__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4329);
/* harmony import */ var _hooks_useModal__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(98266);
/* harmony import */ var _types_modal__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(74701);
/* harmony import */ var _utils_logger__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(78287);
/* harmony import */ var _utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(10712);








var useAuthModal = function() {
    var canOverlayClick = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false, isWritePage = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), showAuthModal = ref[0], setShowAuthModal = ref[1];
    var ref1 = (0,_hooks_useModal__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(), showModal = ref1.showModal, closeModal = ref1.closeModal;
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)({
        campaign: "",
        content: "",
        buttonText: ""
    }), trackInfo = ref2[0], setTrackInfo = ref2[1];
    var isRouteBackPath = router.pathname.includes("/content/qna/write");
    var onClickCancel = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function() {
        setShowAuthModal(false);
        closeModal();
        if ((0,_utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_7__/* .isWebView */ .vp)() && isRouteBackPath) {
            (0,_utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_7__/* .historyBack */ .$i)();
        }
    }, [
        closeModal,
        isRouteBackPath
    ]);
    /** for Webview  */ var onClickLogin = function() {
        if ((0,_utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_7__/* .isWebView */ .vp)()) {
            (0,_utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_7__/* .sendPostMessageToNative */ .T0)(_utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_7__/* .NATIVE_POST_MESSAGE_TYPE.MOVE_TO_LOGIN */ .nn.MOVE_TO_LOGIN);
            setShowAuthModal(false);
            closeModal();
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (showAuthModal) {
            (0,_utils_logger__WEBPACK_IMPORTED_MODULE_6__/* .logger */ .kg)({
                eventName: "sns_login",
                pageName: (0,_utils_logger__WEBPACK_IMPORTED_MODULE_6__/* .getPageName */ .j0)(router)
            });
            if (!(0,_utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_7__/* .isWebView */ .vp)()) {
                showModal({
                    type: _types_modal__WEBPACK_IMPORTED_MODULE_5__/* .MODAL_TYPE.BASIC */ .f.BASIC,
                    props: {
                        body: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_molecules_LoginModal__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            isWritePage: isWritePage,
                            onClick: onClickCancel,
                            trackInfo: trackInfo
                        }),
                        onClickOverlay: canOverlayClick ? onClickCancel : undefined
                    }
                });
            } else {
                showModal({
                    type: _types_modal__WEBPACK_IMPORTED_MODULE_5__/* .MODAL_TYPE.ALERT */ .f.ALERT,
                    props: {
                        title: "로그인이 필요해요",
                        message: "서비스 이용을 위해 로그인해 주세요.",
                        buttons: [
                            {
                                label: "닫기",
                                onClick: function() {
                                    return onClickCancel();
                                }
                            },
                            {
                                type: _types_modal__WEBPACK_IMPORTED_MODULE_5__/* .MODAL_BUTTON_TYPE.PRIMARY */ .J.PRIMARY,
                                label: "로그인",
                                onClick: function() {
                                    return onClickLogin();
                                }
                            }, 
                        ]
                    }
                });
            }
        }
    }, [
        showAuthModal
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        var close = function() {
            closeModal();
        };
        window.addEventListener("popstate", close);
        return function() {
            window.removeEventListener("popstate", close);
        };
    });
    return {
        setShowAuthModal: setShowAuthModal,
        setTrackInfo: setTrackInfo,
        trackInfo: trackInfo
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useAuthModal);


/***/ }),

/***/ 77196:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(62230);
/* harmony import */ var lodash_throttle__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(12436);
/* harmony import */ var lodash_throttle__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_throttle__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);
/* harmony import */ var _utils_logger__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(78287);
/* harmony import */ var _utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(10712);






var useCustomRouter = function() {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    var moveToPage = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function(param) {
        var webLink = param.webLink, mobileScreenName = param.mobileScreenName, params = param.params, as = param.as, _type = param.type, type = _type === void 0 ? _utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_4__/* .NATIVE_POST_MESSAGE_TYPE.MOVE_TO_PAGE */ .nn.MOVE_TO_PAGE : _type;
        if ((0,_utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_4__/* .isWebView */ .vp)()) {
            (0,_utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_4__/* .sendPostMessageToNative */ .T0)(type, {
                screenName: mobileScreenName,
                params: params ? (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, params) : undefined
            });
        } else {
            if (!webLink) return;
            if (type === _utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_4__/* .NATIVE_POST_MESSAGE_TYPE.REPLACE_TO_PAGE */ .nn.REPLACE_TO_PAGE) {
                router.replace(webLink, as);
                return;
            }
            router.push(webLink, as);
        }
    }, [
        router
    ]);
    var getCustomPageName = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function(defaultPageName) {
        return (0,_utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_4__/* .isWebView */ .vp)() ? defaultPageName : (0,_utils_logger__WEBPACK_IMPORTED_MODULE_3__/* .getMobileWebPageName */ .b9)(router);
    }, [
        router
    ]);
    var pageName = (0,_utils_logger__WEBPACK_IMPORTED_MODULE_3__/* .getPageName */ .j0)(router);
    return {
        router: router,
        moveToPage: lodash_throttle__WEBPACK_IMPORTED_MODULE_0___default()(moveToPage, 1500, {
            trailing: false
        }),
        getCustomPageName: getCustomPageName,
        pageName: pageName
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useCustomRouter);


/***/ }),

/***/ 98266:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(62230);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85244);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22386);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(81541);
/* harmony import */ var recoil__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4480);
/* harmony import */ var _recoil_atoms_common_modal__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11221);
/* harmony import */ var _types_modal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74701);







var useModal = function() {
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,recoil__WEBPACK_IMPORTED_MODULE_0__.useRecoilState)(_recoil_atoms_common_modal__WEBPACK_IMPORTED_MODULE_1__/* .modalState */ .e), 2), modals = ref[0], setModals = ref[1];
    var addModal = function(modal) {
        setModals(function(oldModals) {
            return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(oldModals).concat([
                (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, modal), {
                    index: oldModals.length + 1
                }), 
            ]);
        });
    };
    var showModal = function(param) {
        var type = param.type, props = param.props;
        switch(type){
            case _types_modal__WEBPACK_IMPORTED_MODULE_2__/* .MODAL_TYPE.BASIC */ .f.BASIC:
            default:
                addModal({
                    type: type,
                    props: props
                });
                break;
        }
    };
    var closeModal = function() {
        var tempModals = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(modals);
        tempModals.pop();
        setModals(tempModals);
    };
    return {
        isModalOpen: modals.length > 0,
        showModal: showModal,
        closeModal: closeModal
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useModal);


/***/ }),

/***/ 51591:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ry": function() { return /* binding */ REPORT_TYPE; },
/* harmony export */   "bA": function() { return /* binding */ ROLE_TYPE; }
/* harmony export */ });
/* unused harmony export modalType */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(22710);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(81541);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(22970);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(85945);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);
/* harmony import */ var _components_atom_icon_Report_QnaReport__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(24903);
/* harmony import */ var _components_atom_icon_Report_UserBlock__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(76815);
/* harmony import */ var _components_atom_icon_Report_UserReport__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(68764);
/* harmony import */ var _components_atom_icon_Report_UserUnBlock__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(66875);
/* harmony import */ var _types_modal__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(74701);
/* harmony import */ var _qna_mobile_qna_gql_impl__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(4365);
/* harmony import */ var _useModal__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(98266);
/* harmony import */ var _useToast__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(17722);















var REPORT_TYPE = {
    QUESTION: "question",
    ANSWER: "answer",
    BOARD_POST: "board_post",
    BOARD_POST_COMMENT: "board_post_comment"
};
var ROLE_TYPE = {
    USER: "user",
    DOCTOR: "doctor",
    AI: "AI"
};
var modalType = {
    setUserBlock: {
        title: function(target) {
            return "".concat(target, "를 차단할까요?");
        },
        body: function(isUser) {
            return isUser ? "차단한 사용자의 글이 더 이상 보이지 않아요." : "차단한 의료진의 답변을 볼 수 없어요.";
        },
        grantText: "차단",
        toastMessage: function(target) {
            return "".concat(target, "를 차단했어요.");
        }
    },
    resetUserBlock: {
        title: function(target, contentType) {
            return "".concat(target, "의 ").concat(contentType, "을 다시 볼까요?");
        },
        body: function(isUser) {
            return isUser ? "차단을 해제하면 사용자의 글을 볼 수 있어요." : "차단을 해제하면 답변을 볼 수 있어요.";
        },
        grantText: "차단 해제",
        toastMessage: "차단을 해제했어요."
    }
};
var useReportModal = function() {
    var queryClient = (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_11__/* .useQueryClient */ .NL)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), showReportModal = ref[0], setShowReportModal = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(), reportData = ref1[0], setReportData = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(), reportItems = ref2[0], setReportItems = ref2[1];
    var ref3 = (0,_useModal__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(), showModal = ref3.showModal, closeModal = ref3.closeModal;
    var showToast = (0,_useToast__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)().showToast;
    var isUser = (reportData === null || reportData === void 0 ? void 0 : reportData.role) === ROLE_TYPE.USER;
    var isQuestion = (reportData === null || reportData === void 0 ? void 0 : reportData.targetType) === REPORT_TYPE.QUESTION;
    var isBlocked = reportData === null || reportData === void 0 ? void 0 : reportData.isBlocked;
    var targetRoleName = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        return isUser ? "사용자" : "의료진";
    }, [
        isUser
    ]);
    var contentType = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        return isUser ? "글" : "답변";
    }, [
        isUser
    ]);
    var ref4 = (0,_qna_mobile_qna_gql_impl__WEBPACK_IMPORTED_MODULE_8__/* .useSetBlockingAccountMutation */ .vB)({
        onError: function() {
            showToast({
                message: "요청에 실패했습니다."
            });
            onCloseReportModal();
        }
    }), blockMutate = ref4.mutate;
    var onCloseReportModal = function() {
        setShowReportModal(false);
        setReportData(undefined);
        setReportItems([]);
    };
    var onShowReportModal = function(data) {
        setReportData(data);
    };
    var onReportUser = function() {
        next_router__WEBPACK_IMPORTED_MODULE_1___default().push("/content/report?targetId=".concat(reportData === null || reportData === void 0 ? void 0 : reportData.targetId, "&type=").concat(reportData === null || reportData === void 0 ? void 0 : reportData.targetType, "&report_type=user"));
    };
    var onReportQna = function() {
        next_router__WEBPACK_IMPORTED_MODULE_1___default().push("/content/report?targetId=".concat(reportData === null || reportData === void 0 ? void 0 : reportData.targetId, "&type=").concat(reportData === null || reportData === void 0 ? void 0 : reportData.targetType, "&report_type=").concat(reportData === null || reportData === void 0 ? void 0 : reportData.targetType));
    };
    var onBlockMutate = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(function(_isBlocked) {
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_13__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!reportData) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            blockMutate({
                                blockingAccountMutationRequest: {
                                    blockTargetRoleType: reportData === null || reportData === void 0 ? void 0 : reportData.role,
                                    blockTargetId: reportData === null || reportData === void 0 ? void 0 : reportData.roleId
                                }
                            }, {
                                onSuccess: function() {
                                    queryClient.invalidateQueries();
                                    showToast({
                                        message: _isBlocked ? modalType.resetUserBlock.toastMessage : modalType.setUserBlock.toastMessage(targetRoleName)
                                    });
                                    closeModal();
                                    onCloseReportModal();
                                }
                            })
                        ];
                    case 1:
                        _state.sent();
                        _state.label = 2;
                    case 2:
                        return [
                            2
                        ];
                }
            });
        });
        return function onBlockMutate(_isBlocked) {
            return _ref.apply(this, arguments);
        };
    }();
    var onBlockUser = function() {
        onCloseReportModal();
        showModal({
            type: _types_modal__WEBPACK_IMPORTED_MODULE_7__/* .MODAL_TYPE.ALERT */ .f.ALERT,
            props: {
                title: isBlocked ? modalType.resetUserBlock.title(targetRoleName, contentType) : modalType.setUserBlock.title(targetRoleName),
                message: isBlocked ? modalType.resetUserBlock.body(isUser) : modalType.setUserBlock.body(isUser),
                buttons: [
                    {
                        label: "취소",
                        onClick: function() {
                            return closeModal();
                        }
                    },
                    {
                        type: isBlocked ? _types_modal__WEBPACK_IMPORTED_MODULE_7__/* .MODAL_BUTTON_TYPE.BOLD */ .J.BOLD : _types_modal__WEBPACK_IMPORTED_MODULE_7__/* .MODAL_BUTTON_TYPE.DANGER */ .J.DANGER,
                        label: isBlocked ? "차단 해제" : "차단",
                        onClick: function() {
                            return onBlockMutate(isBlocked);
                        }
                    }, 
                ]
            }
        });
    };
    var generateSelectList = function() {
        var selectItems = [];
        if ((reportData === null || reportData === void 0 ? void 0 : reportData.role) !== ROLE_TYPE.AI) {
            selectItems = [
                {
                    Icon: function() {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_atom_icon_Report_UserReport__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {});
                    },
                    text: isUser ? "사용자 신고" : "의료진 신고",
                    onClick: onReportUser
                },
                {
                    Icon: function() {
                        return isBlocked ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_atom_icon_Report_UserUnBlock__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {}) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_atom_icon_Report_UserBlock__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {});
                    },
                    text: isBlocked ? "차단 해제하기" : isUser ? "사용자 차단" : "의료진 차단",
                    onClick: onBlockUser
                }, 
            ];
        }
        if (!isBlocked) selectItems = [
            {
                Icon: function() {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_atom_icon_Report_QnaReport__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {});
                },
                text: isQuestion ? "게시글 신고" : "답변 신고",
                onClick: onReportQna
            }, 
        ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(selectItems));
        setReportItems(selectItems);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (reportItems === null || reportItems === void 0 ? void 0 : reportItems.length) {
            return setShowReportModal(true);
        }
        setShowReportModal(false);
    }, [
        reportItems
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (reportData) {
            generateSelectList();
        }
    }, [
        reportData
    ]);
    return {
        showReportModal: showReportModal,
        onShowReportModal: onShowReportModal,
        onCloseReportModal: onCloseReportModal,
        reportData: reportData,
        reportItems: reportItems
    };
};
/* harmony default export */ __webpack_exports__["ZP"] = (useReportModal);


/***/ }),

/***/ 84670:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ list; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(55351);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./src/components/layouts/DefaultLayout.tsx
var DefaultLayout = __webpack_require__(83651);
// EXTERNAL MODULE: ../../node_modules/next/node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(75190);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(89961);
// EXTERNAL MODULE: ./src/components/atom/BreadCrumbs.tsx
var BreadCrumbs = __webpack_require__(27441);
// EXTERNAL MODULE: ./src/components/atom/icon/Arrow/Arrow.tsx + 1 modules
var Arrow = __webpack_require__(70508);
// EXTERNAL MODULE: ./src/components/common/CommunityCategoryBottomSheet/index.tsx
var CommunityCategoryBottomSheet = __webpack_require__(80230);
// EXTERNAL MODULE: ./src/components/molecules/InfiniteScroll/index.tsx
var InfiniteScroll = __webpack_require__(53086);
// EXTERNAL MODULE: ./src/components/molecules/ScrollTopStickyButton/index.tsx + 1 modules
var ScrollTopStickyButton = __webpack_require__(79771);
// EXTERNAL MODULE: ./node_modules/recoil/es/index.js
var es = __webpack_require__(4480);
// EXTERNAL MODULE: ./src/components/atom/buttons/DefaultButton.tsx
var DefaultButton = __webpack_require__(47641);
// EXTERNAL MODULE: ./src/components/atom/icon/ContentFile.tsx
var ContentFile = __webpack_require__(57849);
// EXTERNAL MODULE: ./src/hooks/useAuthModal.tsx
var useAuthModal = __webpack_require__(71213);
// EXTERNAL MODULE: ./src/hooks/useCustomRouter.tsx
var useCustomRouter = __webpack_require__(77196);
// EXTERNAL MODULE: ./src/recoil/atoms/common/auth.ts
var auth = __webpack_require__(4415);
// EXTERNAL MODULE: ./src/types/common.ts
var common = __webpack_require__(70138);
;// CONCATENATED MODULE: ./src/components/common/PostList/EmptyPostList.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n\n  svg {\n    margin-bottom: 20px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center;\n\n  ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 12px 16px;\n  border-radius: 8px;\n  margin-top: 20px;\n\n  ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}










var EmptyPostList = function(param) {
    var _isMypage = param.isMypage, isMypage = _isMypage === void 0 ? false : _isMypage, _isSearchpage = param.isSearchpage, isSearchpage = _isSearchpage === void 0 ? false : _isSearchpage;
    var token = (0,es.useRecoilValue)(auth/* tokenState */.J1);
    var setShowAuthModal = (0,useAuthModal/* default */.Z)().setShowAuthModal;
    var moveToPage = (0,useCustomRouter/* default */.Z)().moveToPage;
    var ref = (0,react.useState)(0), exceptionSpace = ref[0], setExceptionSpace = ref[1];
    var onClickWrite = function() {
        if (!token) {
            setShowAuthModal(true);
        } else {
            moveToPage({
                webLink: common/* ROUTES.COMMUNITY.WRITE.path */.Z6.COMMUNITY.WRITE.path,
                mobileScreenName: common/* ROUTES.COMMUNITY.WRITE.appScreenName */.Z6.COMMUNITY.WRITE.appScreenName
            });
        }
    };
    var getContentTitle = (0,react.useCallback)(function() {
        if (isMypage) {
            return "작성글이 없어요";
        }
        if (isSearchpage) {
            return "검색 결과가 없어요";
        }
        return "게시글이 없어요";
    }, [
        isMypage,
        isSearchpage
    ]);
    (0,react.useEffect)(function() {
        var ref, ref1;
        var appHeaderHeight = ((ref = document.getElementById("appHeader")) === null || ref === void 0 ? void 0 : ref.clientHeight) || 0;
        var fixedBottomSheetHeight = ((ref1 = document.getElementById("FixedBottomSheet")) === null || ref1 === void 0 ? void 0 : ref1.clientHeight) || 0;
        setExceptionSpace(appHeaderHeight + fixedBottomSheetHeight);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, {
        exceptionSpace: exceptionSpace,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Body, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentFile/* default */.Z, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Content, {
                    children: [
                        getContentTitle(),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: isSearchpage ? "다른 검색어를 입력해주세요." : "첫 게시글을 작성해보세요."
                        })
                    ]
                }),
                !isSearchpage && /*#__PURE__*/ (0,jsx_runtime.jsx)(WriteButton, {
                    onClick: onClickWrite,
                    children: "글쓰러 가기"
                })
            ]
        })
    });
};
/* harmony default export */ var PostList_EmptyPostList = (EmptyPostList);
var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-99b77023-0"
})(_templateObject(), function(param) {
    var theme = param.theme, exceptionSpace = param.exceptionSpace;
    return "\n    background: ".concat(theme.color.white, ";\n    height: calc(100vh - ").concat(exceptionSpace, "px);\n  ");
});
var Body = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-99b77023-1"
})(_templateObject1());
var Content = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-99b77023-2"
})(_templateObject2(), function(param) {
    var theme = param.theme;
    return "\n    ".concat(theme.typography.UI20SB, ";\n    color: ").concat(theme.color.gray700, ";\n\n    p {\n      ").concat(theme.typography.UI14M, ";\n      color: ").concat(theme.color.gray400, ";\n      margin-top: 8px;\n    }\n  ");
});
var WriteButton = (0,styled_components_browser_esm/* default */.ZP)(DefaultButton/* DefaultButtonStyled */.qY).withConfig({
    componentId: "sc-99b77023-3"
})(_templateObject3(), function(param) {
    var theme = param.theme;
    return "\n    ".concat(theme.typography.UI16SB, ";\n    color: ").concat(theme.color.white, ";\n    background: ").concat(theme.color.primary500, ";\n    \n    &: active {\n      background: ").concat(theme.color.primary700, ";\n    }\n  ");
});

// EXTERNAL MODULE: ../../node_modules/next/image.js
var next_image = __webpack_require__(96577);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/components/atom/icon/ChatBubbleTextOval.tsx
var ChatBubbleTextOval = __webpack_require__(46737);
// EXTERNAL MODULE: ./src/components/atom/icon/DotMenu.tsx
var DotMenu = __webpack_require__(48537);
// EXTERNAL MODULE: ./src/components/atom/icon/FavoriteHeart.tsx
var FavoriteHeart = __webpack_require__(17042);
// EXTERNAL MODULE: ./src/components/atom/text/DefaultText.tsx
var DefaultText = __webpack_require__(40202);
// EXTERNAL MODULE: ./src/components/molecules/CommunityUserNickName.tsx + 1 modules
var CommunityUserNickName = __webpack_require__(36221);
// EXTERNAL MODULE: ./src/components/molecules/ProfileImage/index.tsx
var ProfileImage = __webpack_require__(66039);
// EXTERNAL MODULE: ./src/components/templates/mobile/communication/Common/MypageMobileTemplate/DeletedItemByReport.tsx
var DeletedItemByReport = __webpack_require__(88143);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(44376);
// EXTERNAL MODULE: ./src/types/bff/gql-schema.ts
var gql_schema = __webpack_require__(72271);
// EXTERNAL MODULE: ./src/types/community.ts
var community = __webpack_require__(45140);
// EXTERNAL MODULE: ./src/utils/image.ts
var utils_image = __webpack_require__(60288);
;// CONCATENATED MODULE: ./src/components/common/PostList/PostItem.tsx

function PostItem_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n\n  ",
        ";\n"
    ]);
    PostItem_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function PostItem_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 24px 0;\n  ",
        ";\n"
    ]);
    PostItem_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function PostItem_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  gap: 6px;\n  padding-bottom: 16px;\n"
    ]);
    PostItem_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function PostItem_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 5px 10px;\n  border-radius: 4px;\n\n  ",
        "\n"
    ]);
    PostItem_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  margin-bottom: 16px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 1;\n  overflow: hidden;\n  margin-bottom: 8px;\n\n  ",
        ";\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  min-width: 72px;\n  height: 72px;\n  border-radius: 16px;\n  margin-left: 16px;\n  overflow: hidden;\n\n  ",
        "\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-right: 12px;\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-direction: column;\n  display: flex;\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  margin-right: 16px;\n\n  &:nth-last-child(2) {\n    margin-right: 12px;\n  }\n\n  svg {\n    margin-right: 8px;\n  }\n\n  ",
        ";\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 6px;\n  border-radius: 6px;\n  ",
        ";\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}


















var getTagColor = function(type) {
    switch(type){
        case community/* BOARD_POST_TAG_TYPE.POPULAR */.q.POPULAR:
            return "\n          background: ".concat(theme/* default.color.primary200 */.Z.color.primary200, ";\n          color: ").concat(theme/* default.color.primary700 */.Z.color.primary700, ";\n        ");
        case community/* BOARD_POST_TAG_TYPE.RECOMMENDED */.q.RECOMMENDED:
            return "\n          background: ".concat(theme/* default.color.blue200 */.Z.color.blue200, ";\n          color: ").concat(theme/* default.color.blue700 */.Z.color.blue700, ";\n        ");
        case community/* BOARD_POST_TAG_TYPE.DEFAULT */.q.DEFAULT:
        default:
            return "\n          background: ".concat(theme/* default.color.gray50 */.Z.color.gray50, ";\n          color: ").concat(theme/* default.color.gray500 */.Z.color.gray500, ";\n        ");
    }
};
var PostItem = function(param) {
    var post = param.post, isMypage = param.isMypage, containerStyle = param.containerStyle, onClickPost = param.onClickPost, onClickReport = param.onClickReport;
    var ref;
    var profileImage = (0,react.useMemo)(function() {
        return post.communityUser.profileImageUrl;
    }, []);
    var isImageBlind = ((ref = post.boardPostAttachments[0]) === null || ref === void 0 ? void 0 : ref.blindType) === gql_schema/* AttachmentBlindType.Blinded */.jzP.Blinded;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
            href: "".concat(common/* ROUTES.COMMUNITY.DETAIL.path */.Z6.COMMUNITY.DETAIL.path, "/").concat(post.boardPostPid),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                role: "presentation",
                onClick: function(e) {
                    return onClickPost(e, post);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
                    style: containerStyle,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(PostItem_Wrapper, {
                        children: [
                            !!post.tags.length && /*#__PURE__*/ (0,jsx_runtime.jsx)(Tags, {
                                children: post.tags.map(function(tag, key) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tag, {
                                        type: tag.type,
                                        children: tag.label
                                    }, key);
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(BodyWrapper, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(PostItem_Body, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                                                children: post.title
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(PostItem_Content, {
                                                children: post.content
                                            })
                                        ]
                                    }),
                                    !!post.boardPostAttachments.length && !isImageBlind && /*#__PURE__*/ (0,jsx_runtime.jsx)(PostImage, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            alt: "img",
                                            width: 72,
                                            height: 72,
                                            src: (0,utils_image/* resizingImg */.Kp)({
                                                originUrl: (0,utils_image/* redirectPostImage */.R2)(post.boardPostAttachments[0].boardPostAttachmentId),
                                                width: 140,
                                                height: 140
                                            }),
                                            objectFit: "cover"
                                        })
                                    })
                                ]
                            }),
                            isMypage && post.blinded && /*#__PURE__*/ (0,jsx_runtime.jsx)(DeletedItemByReport/* default */.Z, {
                                containerStyle: {
                                    marginBottom: 16
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Bottom, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProfileInfo, {
                                        children: [
                                            !isMypage && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileImageWrapper, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileImage/* default */.Z, {
                                                    width: 32,
                                                    height: 32,
                                                    src: profileImage
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Author, {
                                                children: [
                                                    !isMypage && /*#__PURE__*/ (0,jsx_runtime.jsx)(CommunityUserNickName/* default */.Z, {
                                                        userId: post.communityUser.userId,
                                                        nickName: post.communityUser.nickname
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PostItem_Date, {
                                                        children: post.formattedCreatedAt
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(AsideIcon, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Icon, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FavoriteHeart/* default */.Z, {
                                                        color: theme/* default.color.gray300 */.Z.color.gray300,
                                                        isActive: post.isLikedByMe
                                                    }),
                                                    " ",
                                                    post.likeCount
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Icon, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ChatBubbleTextOval/* default */.Z, {}),
                                                    " ",
                                                    post.boardCommentCount
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonIcon, {
                                                onClick: function(e) {
                                                    return onClickReport(e, post);
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DotMenu/* default */.Z, {})
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        })
    });
};
/* harmony default export */ var PostList_PostItem = (PostItem);
var Container = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
    componentId: "sc-cf542ac2-0"
})(PostItem_templateObject(), function(param) {
    var theme = param.theme;
    return "\n    padding: 0 24px;\n    background: ".concat(theme.color.white, ";\n    \n    &:hover {\n      background: ").concat(theme.color.gray30, ";\n    }\n\n    &:active {\n      background: ").concat(theme.color.gray50, ";\n    }\n  ");
});
var PostItem_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-cf542ac2-1"
})(PostItem_templateObject1(), function(param) {
    var theme = param.theme;
    return "\n    border-bottom: 1px solid ".concat(theme.color.gray40, ";\n  ");
});
var Tags = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-cf542ac2-2"
})(PostItem_templateObject2());
var Tag = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-cf542ac2-3"
})(PostItem_templateObject3(), function(param) {
    var theme = param.theme, type = param.type;
    return "\n    ".concat(theme.typography.UI12M, ";\n    ").concat(getTagColor(type), ";\n  ");
});
var BodyWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-cf542ac2-4"
})(_templateObject4());
var PostItem_Body = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-cf542ac2-5"
})(_templateObject5());
var Title = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-cf542ac2-6"
})(_templateObject6(), function(param) {
    var theme = param.theme;
    return "\n    ".concat(theme.typography.UI18SB, ";\n    color: ").concat(theme.color.gray700, ";\n  ");
});
var PostItem_Content = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-cf542ac2-7"
})(_templateObject7(), function(param) {
    var theme = param.theme;
    return "\n    ".concat(theme.typography.UI14R, ";\n    ").concat(DefaultText/* EllipsisTextStyle */.Ew, ";\n    color: ").concat(theme.color.gray500, ";\n  ");
});
var PostImage = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-cf542ac2-8"
})(_templateObject8(), function(param) {
    var theme = param.theme;
    return "\n    border: 1px solid ".concat(theme.color.gray100, ";\n  ");
});
var Bottom = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-cf542ac2-9"
})(_templateObject9());
var ProfileInfo = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-cf542ac2-10"
})(_templateObject10());
var ProfileImageWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-cf542ac2-11"
})(_templateObject11());
var Author = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-cf542ac2-12"
})(_templateObject12());
var PostItem_Date = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-cf542ac2-13"
})(_templateObject13(), function(param) {
    var theme = param.theme;
    return "\n    ".concat(theme.typography.UI12R, ";\n    color: ").concat(theme.color.gray300, ";\n  ");
});
var AsideIcon = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-cf542ac2-14"
})(_templateObject14());
var Icon = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-cf542ac2-15"
})(_templateObject15(), function(param) {
    var theme = param.theme;
    return "\n    ".concat(theme.typography.UI14M, ";\n    color: ").concat(theme.color.gray300, ";\n  ");
});
var ButtonIcon = (0,styled_components_browser_esm/* default */.ZP)(DefaultButton/* DefaultButtonStyled */.qY).withConfig({
    componentId: "sc-cf542ac2-16"
})(_templateObject16(), function(param) {
    var theme = param.theme;
    return "\n    &: active {\n      background: ".concat(theme.color.gray50, "\n    }\n  ");
});

// EXTERNAL MODULE: ./src/components/atom/Skeleton/index.tsx + 1 modules
var Skeleton = __webpack_require__(13971);
;// CONCATENATED MODULE: ./src/components/common/PostList/PostSkeleton.tsx

function PostSkeleton_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0 20px;\n"
    ]);
    PostSkeleton_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function PostSkeleton_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 20px 0;\n  border-bottom: 1px solid ",
        ";\n"
    ]);
    PostSkeleton_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function PostSkeleton_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n"
    ]);
    PostSkeleton_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function PostSkeleton_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n"
    ]);
    PostSkeleton_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function PostSkeleton_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n"
    ]);
    PostSkeleton_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}



var PostItemSkeleton = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                style: {
                    width: "20%",
                    height: 28,
                    marginBottom: 16
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SpaceBetweenRow, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Column, {
                        style: {
                            width: "100%"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                style: {
                                    height: 25,
                                    marginBottom: 6
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                style: {
                                    width: "80%",
                                    height: 25
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                        style: {
                            minWidth: 70,
                            height: 70,
                            borderRadius: 16,
                            marginLeft: 16
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SpaceBetweenRow, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row, {
                        style: {
                            marginTop: 16,
                            marginBottom: 16
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                style: {
                                    width: 32,
                                    height: 32,
                                    borderRadius: "50%",
                                    marginRight: 12
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Column, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                        style: {
                                            width: 100,
                                            height: 18,
                                            marginBottom: 2
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                        style: {
                                            width: 41,
                                            height: 18
                                        }
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                style: {
                                    width: 32,
                                    height: 20,
                                    marginRight: 16
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                style: {
                                    width: 32,
                                    height: 20,
                                    marginRight: 16
                                }
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var PostsSkeleton = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PostSkeleton_Wrapper, {
        children: Array.from({
            length: 10
        }).map(function(_, i) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(PostItemSkeleton, {}, "skeleton_".concat(i));
        })
    });
};
/* harmony default export */ var PostSkeleton = (PostsSkeleton);
var PostSkeleton_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-113cb8a5-0"
})(PostSkeleton_templateObject());
var Card = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-113cb8a5-1"
})(PostSkeleton_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.color.gray30;
});
var Row = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-113cb8a5-2"
})(PostSkeleton_templateObject2());
var Column = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-113cb8a5-3"
})(PostSkeleton_templateObject3());
var SpaceBetweenRow = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-113cb8a5-4"
})(PostSkeleton_templateObject4());

;// CONCATENATED MODULE: ./src/components/common/PostList/index.tsx

function PostList_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    PostList_templateObject = function _templateObject() {
        return data;
    };
    return data;
}








var PostList = function(param) {
    var posts = param.posts, _isMypage = param.isMypage, isMypage = _isMypage === void 0 ? false : _isMypage, _isSearchpage = param.isSearchpage, isSearchpage = _isSearchpage === void 0 ? false : _isSearchpage, _isVisibleMoveToTopButton = param.isVisibleMoveToTopButton, isVisibleMoveToTopButton = _isVisibleMoveToTopButton === void 0 ? true : _isVisibleMoveToTopButton, onClickPost = param.onClickPost, onClickReport = param.onClickReport, emptyComponent = param.emptyComponent;
    var ref, ref1;
    if (posts.isLoading) return /*#__PURE__*/ (0,jsx_runtime.jsx)(PostSkeleton, {});
    if (!posts.isLoading && !((ref = posts.data) === null || ref === void 0 ? void 0 : ref.length)) return emptyComponent ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: emptyComponent
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(PostList_EmptyPostList, {
        isMypage: isMypage,
        isSearchpage: isSearchpage
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(PostList_Container, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(InfiniteScroll/* default */.Z, {
                rootMargin: "0px 0px 0px 100px",
                isLoading: posts.isLoading,
                hasNextPage: posts.hasNextPage,
                fetchNextPage: posts.fetchNextPage,
                children: (ref1 = posts.data) === null || ref1 === void 0 ? void 0 : ref1.map(function(post) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PostList_PostItem, {
                            post: post,
                            isMypage: isMypage,
                            onClickPost: onClickPost,
                            onClickReport: onClickReport
                        })
                    }, "post_".concat(post.boardPostPid));
                })
            }),
            isVisibleMoveToTopButton && /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollTopStickyButton/* default */.Z, {})
        ]
    });
};
/* harmony default export */ var common_PostList = (PostList);
var PostList_Container = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    componentId: "sc-2612f484-0"
})(PostList_templateObject());

// EXTERNAL MODULE: ../../node_modules/swiper/swiper.esm.js + 90 modules
var swiper_esm = __webpack_require__(76453);
// EXTERNAL MODULE: ../../node_modules/swiper/react/swiper-react.js + 15 modules
var swiper_react = __webpack_require__(57506);
// EXTERNAL MODULE: ./src/components/atom/icon/HandHeldTabletWriting.tsx
var HandHeldTabletWriting = __webpack_require__(83384);
;// CONCATENATED MODULE: ./src/components/atom/icon/Trophy.tsx

var Trophy = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_3036_51256)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M0.857143 0C0.629814 0 0.411797 0.0903059 0.251051 0.251051C0.0903059 0.411797 0 0.629814 0 0.857143L0 4.02286C0 5.1595 0.451529 6.24959 1.25526 7.05332C2.05898 7.85704 3.14907 8.30857 4.28571 8.30857H4.72571C4.95304 8.30857 5.17106 8.21827 5.33181 8.05752C5.49255 7.89678 5.58286 7.67876 5.58286 7.45143V0.857143C5.58286 0.629814 5.49255 0.411797 5.33181 0.251051C5.17106 0.0903059 4.95304 0 4.72571 0L0.857143 0ZM1.71429 4.02286V1.71429H3.86857V6.56C3.26701 6.4611 2.72016 6.1517 2.32557 5.68699C1.93099 5.22228 1.71434 4.63249 1.71429 4.02286ZM15.1429 0C15.3702 0 15.5882 0.0903059 15.7489 0.251051C15.9097 0.411797 16 0.629814 16 0.857143V4.02286C16 5.1595 15.5485 6.24959 14.7447 7.05332C13.941 7.85704 12.8509 8.30857 11.7143 8.30857H11.2743C11.047 8.30857 10.8289 8.21827 10.6682 8.05752C10.5074 7.89678 10.4171 7.67876 10.4171 7.45143V0.857143C10.4171 0.629814 10.5074 0.411797 10.6682 0.251051C10.8289 0.0903059 11.047 0 11.2743 0L15.1429 0ZM14.2857 4.02286V1.71429H12.1314V6.56C12.733 6.4611 13.2798 6.1517 13.6744 5.68699C14.069 5.22228 14.2857 4.63249 14.2857 4.02286ZM8 9.89029C8.22733 9.89029 8.44535 9.98059 8.60609 10.1413C8.76684 10.3021 8.85714 10.5201 8.85714 10.7474V14.2857H11.8457C12.073 14.2857 12.2911 14.376 12.4518 14.5368C12.6126 14.6975 12.7029 14.9155 12.7029 15.1429C12.7029 15.3702 12.6126 15.5882 12.4518 15.7489C12.2911 15.9097 12.073 16 11.8457 16H8.02971C8.00991 16.0007 7.99009 16.0007 7.97029 16H4.15314C3.92581 16 3.7078 15.9097 3.54705 15.7489C3.38631 15.5882 3.296 15.3702 3.296 15.1429C3.296 14.9155 3.38631 14.6975 3.54705 14.5368C3.7078 14.376 3.92581 14.2857 4.15314 14.2857H7.14286V10.7474C7.14286 10.5201 7.23316 10.3021 7.39391 10.1413C7.55465 9.98059 7.77267 9.89029 8 9.89029Z",
                        fill: "#F08C00"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M4.00014 0.00228882C3.84859 0.00228882 3.70324 0.0624927 3.59608 0.169656C3.48891 0.27682 3.42871 0.422165 3.42871 0.573717V6.85715C3.42871 8.06956 3.91034 9.23232 4.76765 10.0896C5.62496 10.9469 6.78772 11.4286 8.00014 11.4286C9.21256 11.4286 10.3753 10.9469 11.2326 10.0896C12.0899 9.23232 12.5716 8.06956 12.5716 6.85715V0.573717C12.5716 0.422165 12.5114 0.27682 12.4042 0.169656C12.297 0.0624927 12.1517 0.00228882 12.0001 0.00228882H4.00014Z",
                        fill: "#FCC419"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_3036_51256",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "16",
                        height: "16",
                        fill: "white"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var icon_Trophy = (Trophy);

// EXTERNAL MODULE: ./src/constants/zIndex.ts
var zIndex = __webpack_require__(31591);
// EXTERNAL MODULE: ./src/hooks/community/mobile/community.gql.impl.tsx
var community_gql_impl = __webpack_require__(42549);
// EXTERNAL MODULE: ./src/hooks/useModal.tsx
var useModal = __webpack_require__(98266);
// EXTERNAL MODULE: ./src/services/community/index.tsx
var services_community = __webpack_require__(29178);
// EXTERNAL MODULE: ./src/types/modal.ts
var modal = __webpack_require__(74701);
// EXTERNAL MODULE: ./src/utils/date.ts
var date = __webpack_require__(30918);
// EXTERNAL MODULE: ./src/utils/logger/index.ts
var logger = __webpack_require__(78287);
// EXTERNAL MODULE: ./src/utils/mobile/RNPlugins.tsx
var RNPlugins = __webpack_require__(10712);
;// CONCATENATED MODULE: ./src/components/common/WriteFixedBottomSheet/index.tsx

function WriteFixedBottomSheet_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  0% {\n    transform: translateY(100%);\n  }\n  100% {\n    transform: translateY(0);\n  }\n"
    ]);
    WriteFixedBottomSheet_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function WriteFixedBottomSheet_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: fixed;\n  width: ",
        ";\n  display: ",
        ";\n  max-width: inherit;\n  background: white;\n  box-shadow: 0 -2px 8px rgb(0 0 0 / 8%);\n  border-radius: 16px 16px 0 0;\n  bottom: 0;\n  animation: ",
        " 0.3s;\n  z-index: ",
        ";\n"
    ]);
    WriteFixedBottomSheet_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function WriteFixedBottomSheet_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  padding: 0 16px;\n  align-items: center;\n  margin: 0 auto;\n  max-width: inherit;\n  ",
        "\n"
    ]);
    WriteFixedBottomSheet_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function WriteFixedBottomSheet_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  position: relative;\n\n  svg {\n    margin-right: 12px;\n  }\n"
    ]);
    WriteFixedBottomSheet_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function WriteFixedBottomSheet_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 40px;\n  padding: 0 21.5px;\n  border-radius: 8px;\n\n  ",
        "\n"
    ]);
    WriteFixedBottomSheet_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function WriteFixedBottomSheet_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 68px;\n  width: 100%;\n"
    ]);
    WriteFixedBottomSheet_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function WriteFixedBottomSheet_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  height: 100%;\n  width: 100%;\n  align-items: center;\n"
    ]);
    WriteFixedBottomSheet_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function WriteFixedBottomSheet_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  height: 16px;\n  width: 100%;\n  z-index: 2;\n  ",
        ";\n"
    ]);
    WriteFixedBottomSheet_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}





















var WriteFixedBottomSheet = function(param) {
    var pageName = param.pageName, selectedCategory = param.selectedCategory, _width = param.width, width = _width === void 0 ? 768 : _width;
    var token = (0,es.useRecoilValue)(auth/* tokenState */.J1);
    var setShowAuthModal = (0,useAuthModal/* default */.Z)().setShowAuthModal;
    var ref = (0,useCustomRouter/* default */.Z)(), moveToPage = ref.moveToPage, router = ref.router;
    var ref1 = (0,useModal/* default */.Z)(), showModal = ref1.showModal, closeModal = ref1.closeModal;
    var ref2 = (0,react.useState)([]), activeBanners = ref2[0], setActiveBanners = ref2[1];
    // 유저 정보 가져오기
    var ref3 = (0,community_gql_impl/* useGetCommunityUserQuery */.K_)({}, {
        enabled: !!token,
        select: function(data) {
            return (0,services_community/* communityUserService */.mT)(data);
        },
        refetchOnWindowFocus: true
    }), communityUser = ref3.data;
    var banners = (0,react.useMemo)(function() {
        return [
            {
                Icon: function() {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(HandHeldTabletWriting/* default */.Z, {});
                },
                title: "커뮤니티 이용가이드를 읽어보세요.",
                headerTitle: "커뮤니티 이용가이드",
                uri: "https://company.doctornow.co.kr/communityguide",
                startAt: "2023-06-07 15:00",
                endAt: "2025-06-07 15:00"
            },
            {
                Icon: function() {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_Trophy, {});
                },
                title: "커뮤니티 우수 회원 발표!",
                headerTitle: "우수 회원 발표",
                uri: "https://company.doctornow.co.kr/community_prize_4/",
                startAt: "2023-09-01 15:00",
                endAt: "2023-09-05 15:00"
            }, 
        ];
    }, []);
    var onClickWrite = function() {
        if (!token) return setShowAuthModal(true);
        if (communityUser === null || communityUser === void 0 ? void 0 : communityUser.isBanned) {
            showModal({
                type: modal/* MODAL_TYPE.ALERT */.f.ALERT,
                props: {
                    title: "커뮤니티 정책을 위반했어요.",
                    message: "제한 기간 동안 게시글과 댓글을 쓸 수 없어요.\n(제한 기간 : ".concat(communityUser.formattedBannedDate, ")"),
                    buttons: [
                        {
                            type: modal/* MODAL_BUTTON_TYPE.DEFAULT */.J.DEFAULT,
                            label: "확인",
                            onClick: closeModal
                        }, 
                    ]
                }
            });
        } else {
            (0,logger/* mobileLogger */.Pp)({
                logger: {
                    eventName: "comm_write_bottom_sheet_click",
                    pageName: pageName,
                    payload: router.query
                }
            });
            moveToPage({
                webLink: "".concat(common/* ROUTES.COMMUNITY.WRITE.path */.Z6.COMMUNITY.WRITE.path).concat(selectedCategory ? "?categoryId=".concat(selectedCategory.boardCategoryId, "&categoryName=").concat(selectedCategory.name) : ""),
                mobileScreenName: common/* ROUTES.COMMUNITY.WRITE.appScreenName */.Z6.COMMUNITY.WRITE.appScreenName,
                params: {
                    categoryId: (selectedCategory === null || selectedCategory === void 0 ? void 0 : selectedCategory.boardCategoryId) || "",
                    categoryName: (selectedCategory === null || selectedCategory === void 0 ? void 0 : selectedCategory.name) || ""
                }
            });
        }
    };
    var onClickContent = function(uri, key) {
        (0,logger/* mobileLogger */.Pp)({
            logger: {
                eventName: "comm_bottom_sheet_content_click",
                pageName: pageName,
                payload: {
                    link: uri
                }
            }
        });
        moveToPage({
            webLink: banners[key].uri,
            mobileScreenName: common/* ROUTES.COMMON.PURE_WEBVIEW.appScreenName */.Z6.COMMON.PURE_WEBVIEW.appScreenName,
            params: {
                headerTitle: banners[key].headerTitle,
                uri: banners[key].uri
            }
        });
    };
    (0,react.useEffect)(function() {
        setActiveBanners(banners.filter(function(banner) {
            return (0,date/* isBetweenDate */.Ut)({
                startAt: banner.startAt,
                endAt: banner.endAt,
                unitType: "minutes"
            });
        }));
    }, [
        banners
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(WriteFixedBottomSheet_Wrapper, {
        id: "FixedBottomSheet",
        width: width,
        isWebView: (0,RNPlugins/* isWebView */.vp)(),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(WriteFixedBottomSheet_Body, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(WriteFixedBottomSheet_Content, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Gradient, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SwiperContainer, {
                            slidesPerView: 1,
                            direction: "vertical",
                            modules: [
                                swiper_esm/* Autoplay */.pt
                            ],
                            autoplay: {
                                delay: 3000,
                                disableOnInteraction: false
                            },
                            loop: activeBanners.length > 1,
                            children: activeBanners.map(function(event, key) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                    onClick: function() {
                                        return onClickContent(event.uri, key);
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BannerItem, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(event.Icon, {}),
                                            event.title
                                        ]
                                    })
                                }, event.uri);
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Gradient, {
                            bottom: true
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(WriteFixedBottomSheet_WriteButton, {
                    onClick: onClickWrite,
                    children: "글쓰기"
                })
            ]
        })
    });
};
/* harmony default export */ var common_WriteFixedBottomSheet = (WriteFixedBottomSheet);
var BottomUp = (0,styled_components_browser_esm/* keyframes */.F4)(WriteFixedBottomSheet_templateObject());
var WriteFixedBottomSheet_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8b54a1fe-0"
})(WriteFixedBottomSheet_templateObject1(), function(param) {
    var width = param.width, isWebView = param.isWebView;
    return isWebView ? "100%" : "".concat(width, "px");
}, function(param) {
    var width = param.width;
    return width > 0 ? "block" : "none";
}, BottomUp, zIndex/* zIndex.BottomSticky */.W.BottomSticky);
var WriteFixedBottomSheet_Body = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8b54a1fe-1"
})(WriteFixedBottomSheet_templateObject2(), function(param) {
    var theme = param.theme;
    return "\n    ".concat(theme.typography.UI14SB, ";\n    color: ").concat(theme.color.gray500, ";\n  ");
});
var WriteFixedBottomSheet_Content = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8b54a1fe-2"
})(WriteFixedBottomSheet_templateObject3());
var WriteFixedBottomSheet_WriteButton = (0,styled_components_browser_esm/* default */.ZP)(DefaultButton/* DefaultButtonStyled */.qY).withConfig({
    componentId: "sc-8b54a1fe-3"
})(WriteFixedBottomSheet_templateObject4(), function(param) {
    var theme = param.theme;
    return "\n    ".concat(theme.typography.UI14SB, ";\n    color: ").concat(theme.color.white, ";\n    background: ").concat(theme.color.primary500, ";\n    &: active {\n      background: ").concat(theme.color.primary700, ";\n    }\n  ");
});
var SwiperContainer = (0,styled_components_browser_esm/* default */.ZP)(swiper_react/* Swiper */.tq).withConfig({
    componentId: "sc-8b54a1fe-4"
})(WriteFixedBottomSheet_templateObject5());
var BannerItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8b54a1fe-5"
})(WriteFixedBottomSheet_templateObject6());
var Gradient = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8b54a1fe-6"
})(WriteFixedBottomSheet_templateObject7(), function(param) {
    var bottom = param.bottom;
    return bottom ? "\n        background: linear-gradient(180deg, #ffffff 0%, rgba(255, 255, 255, 0) 100%); \n        top: 0" : "\n        background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #ffffff 100%); \n        bottom: 0";
});

// EXTERNAL MODULE: ./src/components/layouts/TemplateLayout.tsx
var TemplateLayout = __webpack_require__(75275);
// EXTERNAL MODULE: ./src/components/molecules/Modal/SelectModal/ReportSelectModal/index.tsx
var ReportSelectModal = __webpack_require__(28879);
// EXTERNAL MODULE: ./src/components/molecules/PullToRefresh/index.tsx
var PullToRefresh = __webpack_require__(22909);
// EXTERNAL MODULE: ./src/components/molecules/StickyAppHeader/index.tsx + 4 modules
var StickyAppHeader = __webpack_require__(77314);
// EXTERNAL MODULE: ../../node_modules/next/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(22710);
// EXTERNAL MODULE: ../../node_modules/next/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(62230);
// EXTERNAL MODULE: ../../node_modules/next/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(85244);
// EXTERNAL MODULE: ../../node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(22970);
// EXTERNAL MODULE: ../../node_modules/next/node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(22386);
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(27484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ./src/components/atom/icon/ValidationCheck.tsx
var ValidationCheck = __webpack_require__(23773);
// EXTERNAL MODULE: ./src/components/molecules/BottomSheet/index.tsx + 5 modules
var BottomSheet = __webpack_require__(39535);
;// CONCATENATED MODULE: ./src/components/common/CommunityCloseNotice.tsx

function CommunityCloseNotice_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    background-color: ",
        ";\n  "
    ]);
    CommunityCloseNotice_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CommunityCloseNotice_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: calc(100% - 40px);\n  padding: 24px;\n  border-radius: 16px;\n  ",
        "\n"
    ]);
    CommunityCloseNotice_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function CommunityCloseNotice_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 560px;\n  width: 100%;\n  padding: 24px 20px 32px;\n  border-top-left-radius: 16px;\n  border-top-right-radius: 16px;\n"
    ]);
    CommunityCloseNotice_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function CommunityCloseNotice_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    ",
        "\n    color: ",
        ";\n  "
    ]);
    CommunityCloseNotice_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function CommunityCloseNotice_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  margin: 8px 0;\n"
    ]);
    CommunityCloseNotice_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function CommunityCloseNotice_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    ",
        "\n    color: ",
        ";\n    margin-bottom: 12px;\n  "
    ]);
    CommunityCloseNotice_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function CommunityCloseNotice_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    CommunityCloseNotice_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function CommunityCloseNotice_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    ",
        "\n    color: ",
        ";\n    white-space: pre-line;\n    & > span {\n      ",
        "\n    }\n  "
    ]);
    CommunityCloseNotice_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function CommunityCloseNotice_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    CommunityCloseNotice_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function CommunityCloseNotice_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 40px;\n"
    ]);
    CommunityCloseNotice_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function CommunityCloseNotice_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    ",
        "\n    color: ",
        ";\n    border: 1px solid ",
        ";\n  "
    ]);
    CommunityCloseNotice_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function CommunityCloseNotice_templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-height: 270px;\n  height: 100%;\n  overflow-y: scroll;\n  border-radius: 8px;\n  padding: 16px;\n  ",
        "\n  margin-bottom: 24px;\n"
    ]);
    CommunityCloseNotice_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function CommunityCloseNotice_templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      background-color: ",
        ";\n      border-color: ",
        ";\n    "
    ]);
    CommunityCloseNotice_templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function CommunityCloseNotice_templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 22px;\n  height: 22px;\n  border: 2px solid ",
        ";\n  border-radius: 4px;\n  ",
        "\n  transition: background-color 0.3s, border-color 0.3s;\n"
    ]);
    CommunityCloseNotice_templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function CommunityCloseNotice_templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    & > span {\n      flex: 1;\n      ",
        "\n      color: ",
        ";\n    }\n  "
    ]);
    CommunityCloseNotice_templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function CommunityCloseNotice_templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  ",
        "\n  margin-bottom: 20px;\n"
    ]);
    CommunityCloseNotice_templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function CommunityCloseNotice_templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    ",
        "\n    color: ",
        ";\n    background-color: ",
        ";\n  "
    ]);
    CommunityCloseNotice_templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 56px;\n  padding: 0 24px;\n  border-radius: 12px;\n  ",
        "\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}






var CommunityCloseNotice = function(param) {
    var client = param.client, onCloseWithTodayInvisible = param.onCloseWithTodayInvisible;
    var ref = (0,react.useState)(false), todayInvisible = ref[0], setTodayInvisible = ref[1];
    if (client.isWebView) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MobileWrapper, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(OutOfServiceSvg, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileHeader, {
                    children: "커뮤니티 서비스 중단 안내"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(MobileContentScrollWrapper, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CommunityCloseNotice_Content, {
                            children: "안녕하세요. 닥터나우 입니다.\n먼저 커뮤니티 서비스를 아껴주신 여러분께\n진심으로 감사의 말씀을 전합니다."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CommunityCloseNotice_Content, {
                            children: "아쉽지만 커뮤니티 서비스는"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(CommunityCloseNotice_Content, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: "2024년 8월 30일부로 잠정 중단"
                                }),
                                "될 예정이에요."
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CommunityCloseNotice_Content, {
                            children: "더 좋은 서비스를 위해 잠시 쉬어가는 것이니\n여러분들의 많은 양해 부탁드립니다."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CommunityCloseNotice_Content, {
                            children: "재정비 후 개편된 커뮤니티 서비스로 찾아 뵙겠습니다."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CommunityCloseNotice_Content, {
                            children: "감사합니다"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(CheckButton, {
                    onClick: function() {
                        return setTodayInvisible(function(prev) {
                            return !prev;
                        });
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Check, {
                            checked: todayInvisible,
                            children: todayInvisible ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ValidationCheck/* default */.Z, {
                                size: 20,
                                fill: theme/* default.color.white */.Z.color.white
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: "오늘 하루 보이지 않기"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseButton, {
                    onClick: function() {
                        return onCloseWithTodayInvisible(todayInvisible);
                    },
                    children: "닫기"
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BottomSheet/* default */.ZP, {
        isOpened: true,
        index: 200,
        onClickOverlay: function() {
            return onCloseWithTodayInvisible(false);
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CommunityCloseNotice_Wrapper, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(OutOfServiceSvg, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Header, {
                    children: "커뮤니티 서비스 중단 안내"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentWrapper, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CommunityCloseNotice_Content, {
                            children: "안녕하세요. 닥터나우 입니다.\n먼저 커뮤니티 서비스를 아껴주신 여러분께\n진심으로 감사의 말씀을 전합니다."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CommunityCloseNotice_Content, {
                            children: "아쉽지만 커뮤니티 서비스는"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(CommunityCloseNotice_Content, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: "2024년 8월 30일부로 잠정 중단"
                                }),
                                "될 예정이에요."
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CommunityCloseNotice_Content, {
                            children: "더 좋은 서비스를 위해 잠시 쉬어가는 것이니\n여러분들의 많은 양해 부탁드립니다."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CommunityCloseNotice_Content, {
                            children: "재정비 후 개편된 커뮤니티 서비스로 찾아 뵙겠습니다."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CommunityCloseNotice_Content, {
                            children: "감사합니다"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(CheckButton, {
                    onClick: function() {
                        return setTodayInvisible(function(prev) {
                            return !prev;
                        });
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Check, {
                            checked: todayInvisible,
                            children: todayInvisible ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ValidationCheck/* default */.Z, {
                                size: 20,
                                fill: theme/* default.color.primary600 */.Z.color.primary600
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: "오늘 하루 보이지 않기"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseButton, {
                    onClick: function() {
                        return onCloseWithTodayInvisible(todayInvisible);
                    },
                    children: "닫기"
                })
            ]
        })
    });
};
/* harmony default export */ var common_CommunityCloseNotice = (CommunityCloseNotice);
var MobileWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-14e56134-0"
})(CommunityCloseNotice_templateObject1(), function(param) {
    var _$theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(CommunityCloseNotice_templateObject(), _$theme.color.white);
});
var CommunityCloseNotice_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-14e56134-1"
})(CommunityCloseNotice_templateObject2());
var Header = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-14e56134-2"
})(CommunityCloseNotice_templateObject4(), function(param) {
    var _$theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(CommunityCloseNotice_templateObject3(), _$theme.typography.UI22SB, _$theme.color.gray900);
});
var MobileHeader = (0,styled_components_browser_esm/* default */.ZP)(Header).withConfig({
    componentId: "sc-14e56134-3"
})(CommunityCloseNotice_templateObject6(), function(param) {
    var _$theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(CommunityCloseNotice_templateObject5(), _$theme.typography.UI18SB, _$theme.color.gray900);
});
var CommunityCloseNotice_Content = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-14e56134-4"
})(CommunityCloseNotice_templateObject8(), function(param) {
    var _$theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(CommunityCloseNotice_templateObject7(), _$theme.typography.UI15R, _$theme.color.gray600, _$theme.typography.UI15B);
});
var ContentWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-14e56134-5"
})(CommunityCloseNotice_templateObject9());
var MobileContentScrollWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-14e56134-6"
})(CommunityCloseNotice_templateObject11(), function(param) {
    var _$theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(CommunityCloseNotice_templateObject10(), _$theme.typography.UI18SB, _$theme.color.gray900, _$theme.color.gray100);
});
var Check = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-14e56134-7"
})(CommunityCloseNotice_templateObject13(), theme/* default.color.gray100 */.Z.color.gray100, function(param) {
    var checked = param.checked;
    return checked && (0,styled_components_browser_esm/* css */.iv)(CommunityCloseNotice_templateObject12(), theme/* default.color.primary600 */.Z.color.primary600, theme/* default.color.primary600 */.Z.color.primary600);
});
var CheckButton = styled_components_browser_esm/* default.button.attrs */.ZP.button.attrs({
    type: "button"
}).withConfig({
    componentId: "sc-14e56134-8"
})(CommunityCloseNotice_templateObject15(), function(param) {
    var _$theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(CommunityCloseNotice_templateObject14(), _$theme.typography.UI15R, _$theme.color.gray600);
});
var CloseButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-14e56134-9"
})(_templateObject17(), function(param) {
    var _$theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(CommunityCloseNotice_templateObject16(), _$theme.typography.UI17SB, _$theme.color.gray600, _$theme.color.gray50);
});
var OutOfServiceSvg = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0.369847 23.7613C1.03018 19.8102 4.60009 15.324 6.30251 13.5748C13.2773 8.43012 22.2433 11.4655 25.287 12.9575C25.7685 13.5405 26.2053 14.1099 28.4339 16.8674C31.2197 20.3144 31.9419 25.8192 31.9935 26.5909C32.0451 27.3626 31.7872 28.2886 31.2713 28.8545C30.8586 29.3073 29.7924 29.7977 29.3109 29.9864L24.668 31.8385C24.3791 31.9208 24.1005 31.6327 23.9973 31.4783L21.6243 26.7452V27.8256H10.2232V26.7452C9.58697 28.1171 8.24223 30.9845 7.95334 31.4783C7.66444 31.9722 7.2139 31.8556 7.02475 31.7356L3.87786 30.4494C-0.146036 28.8545 -0.455567 28.7002 0.369847 23.7613Z",
                fill: "#EDEFF0"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M24.598 19.4463C24.3382 16.0393 22.514 16 22.4367 16C22.3185 16 22.2222 16.0961 22.2222 16.2139C22.2222 16.3318 22.3185 16.4279 22.4367 16.4279C22.4513 16.4279 23.9296 16.4628 24.1675 19.4477C23.5195 19.5511 23.0234 20.1114 23.0234 20.7852V23.3961C23.0234 23.514 23.1197 23.61 23.2379 23.61C23.3561 23.61 23.4524 23.514 23.4524 23.3961V20.7852C23.4524 20.2729 23.8698 19.8567 24.3835 19.8567C24.8972 19.8567 25.3145 20.2729 25.3145 20.7852V23.3961C25.3145 23.514 25.4109 23.61 25.5291 23.61C25.6473 23.61 25.7436 23.514 25.7436 23.3961V20.7852C25.7436 20.1099 25.246 19.5496 24.5965 19.4463H24.598Z",
                fill: "#303030"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M24.0624 26.6547C23.5487 26.6547 23.1313 26.2384 23.1313 25.7262V23.5053C23.1313 23.4456 23.1795 23.399 23.2379 23.399C23.2963 23.399 23.3444 23.4471 23.3444 23.5053V25.7262C23.3444 26.1206 23.6655 26.4407 24.061 26.4407C24.1208 26.4407 24.1675 26.4888 24.1675 26.547C24.1675 26.6052 24.1193 26.6532 24.061 26.6532L24.0624 26.6547Z",
                fill: "#A5A5A5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M24.0418 26.2961L23.9046 26.2933C23.769 26.2904 23.6569 26.3977 23.654 26.5328C23.6512 26.668 23.7588 26.7798 23.8943 26.7827L24.0316 26.7855C24.1671 26.7884 24.2792 26.6811 24.2821 26.546C24.2849 26.4108 24.1774 26.299 24.0418 26.2961Z",
                fill: "#CBCBCB"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M24.7076 26.6546C24.6478 26.6546 24.6011 26.6066 24.6011 26.5484C24.6011 26.4902 24.6492 26.4422 24.7076 26.4422C25.1031 26.4422 25.4242 26.122 25.4242 25.7276V23.5067C25.4242 23.4471 25.4723 23.4005 25.5307 23.4005C25.5891 23.4005 25.6372 23.4485 25.6372 23.5067V25.7276C25.6372 26.2399 25.2198 26.6561 24.7062 26.6561L24.7076 26.6546Z",
                fill: "#A5A5A5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M24.8283 26.7857L24.9656 26.7828C25.1011 26.78 25.2086 26.6682 25.2058 26.533C25.203 26.3979 25.0908 26.2906 24.9553 26.2934L24.818 26.2963C24.6825 26.2991 24.5749 26.411 24.5778 26.5461C24.5806 26.6813 24.6928 26.7885 24.8283 26.7857Z",
                fill: "#CBCBCB"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M10.2146 27.8843V17.0804H21.7704V27.8843H10.2146Z",
                fill: "#1B64B1"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ellipse", {
                cx: "8.04768",
                cy: "12.5016",
                rx: "2.57942",
                ry: "2.62379",
                fill: "#FEC7A8"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ellipse", {
                cx: "23.9368",
                cy: "12.5016",
                rx: "2.57942",
                ry: "2.62379",
                fill: "#FEC7A8"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ellipse", {
                cx: "15.9403",
                cy: "10.3408",
                rx: "9.54385",
                ry: "9.62057",
                fill: "#FFDED0"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M19.7893 0.806638C17.1928 -0.480052 15.7864 0.0560692 15.4078 0.484966C13.8932 -0.501494 10.9542 1.25341 9.67403 2.25416C4.22153 7.05781 6.18272 13.1109 7.84155 15.4341C11.1736 14.8336 12.7573 12.369 13.1359 11.3146C16.468 12.9444 21.9903 14.4528 24.2982 14.9711C25.2503 14.0704 25.6673 11.2074 25.7935 9.92069C25.8476 5.63172 23.0348 2.415 19.7893 0.806638Z",
                fill: "#1C1D1F"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ellipse", {
                cx: "13.8262",
                cy: "17.3894",
                rx: "0.722638",
                ry: "0.514755",
                fill: "#1C1D1F"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ellipse", {
                cx: "18.1594",
                cy: "17.3894",
                rx: "0.722638",
                ry: "0.514755",
                fill: "#1C1D1F"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M15.3425 30.3498C15.0548 29.6825 11.7901 27.6735 10.2148 26.7524L8.0481 31.2361L8.61315 31.5489C9.10629 31.8409 9.81176 31.9486 10.1028 31.966C11.3357 32.0008 13.9966 32.039 14.7774 31.9139C15.7534 31.7575 15.702 31.184 15.3425 30.3498Z",
                fill: "#FFDED0"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16.6426 30.5089C16.9303 29.9075 20.307 27.8912 21.8823 27.0611L23.937 31.3077L23.372 31.5896C22.8788 31.8528 22.1733 31.9499 21.8823 31.9655C20.6494 31.9968 17.9885 32.0313 17.2077 31.9185C16.2317 31.7776 16.2831 31.2607 16.6426 30.5089Z",
                fill: "#FFDED0"
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/recoil/atoms/common/popup.ts
var popup = __webpack_require__(17454);
;// CONCATENATED MODULE: ./src/hooks/community/board/useCommunityPopup.tsx










var useCommunityPopup = function(client) {
    var ref = (0,useModal/* default */.Z)(), showModal = ref.showModal, closeModal = ref.closeModal;
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,es.useRecoilState)(popup/* closedCommunityPopupDayState */.n), 2), closedCommunityPopupDay = ref1[0], setClosedCommunityPopupDay = ref1[1];
    var isClosedTodayCommunityPopup = (0,react.useMemo)(function() {
        if (!closedCommunityPopupDay) return false;
        return (0,date/* isSameDate */.Fo)(closedCommunityPopupDay, "date");
    }, [
        closedCommunityPopupDay
    ]);
    var onClosePopupToday = function(todayInvisible) {
        if (todayInvisible) {
            var today = dayjs_min_default()().format();
            setClosedCommunityPopupDay(today);
        }
        closeModal();
    };
    var onOpenCommunityCloseNotice = function() {
        if (isClosedTodayCommunityPopup) {
            return;
        }
        showModal({
            type: modal/* MODAL_TYPE.BASIC */.f.BASIC,
            props: {
                body: /*#__PURE__*/ (0,jsx_runtime.jsx)(common_CommunityCloseNotice, {
                    client: client,
                    onCloseWithTodayInvisible: onClosePopupToday
                })
            }
        });
    };
    return {
        onOpenCommunityCloseNotice: onOpenCommunityCloseNotice
    };
};
/* harmony default export */ var board_useCommunityPopup = (useCommunityPopup);

// EXTERNAL MODULE: ./src/parsers/Communication/community/index.ts
var Communication_community = __webpack_require__(75145);
;// CONCATENATED MODULE: ./src/hooks/community/useGetBoardCategories.ts


var useGetBoardCategories = function() {
    var ref = (0,community_gql_impl/* useGetBoardCategoriesQuery */.hw)({}, {
        select: function(data) {
            return (0,Communication_community/* parseBoardCategories */.kN)(data);
        }
    }), categories = ref.data;
    return {
        categories: categories
    };
};
/* harmony default export */ var community_useGetBoardCategories = (useGetBoardCategories);

// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/useInfiniteQuery.mjs + 1 modules
var useInfiniteQuery = __webpack_require__(59403);
;// CONCATENATED MODULE: ./src/hooks/community/mobile/useGetNewestBoardPostInfinite.tsx




var useGetNewestBoardPostInfinite = function(variables, queryOptions) {
    return (0,useInfiniteQuery/* useInfiniteQuery */.N)([
        "getNewestBoardPostCursorPage",
        variables
    ], function(param) {
        var pageParam = param.pageParam;
        return community_gql_impl/* useGetNewestBoardPostCursorPageQuery.fetcher */.xQ.fetcher({
            request: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, variables.request), {
                pivot: pageParam
            })
        })();
    }, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, queryOptions), {
        getNextPageParam: function(lastPage) {
            var size = variables.request.size;
            if (!lastPage) {
                return undefined;
            }
            if (lastPage.newestBoardPostCursorPage.elements.length < size) {
                return undefined;
            }
            return lastPage.newestBoardPostCursorPage.pivot;
        }
    }));
};
useGetNewestBoardPostInfinite.getKey = function(variables) {
    return [
        "getNewestBoardPostCursorPage",
        variables
    ];
};
/* harmony default export */ var mobile_useGetNewestBoardPostInfinite = (useGetNewestBoardPostInfinite);

;// CONCATENATED MODULE: ./src/hooks/community/useGetNewestBoardPost.ts


var useGetNewestBoardPost = function(boardCategoryId) {
    var ref = mobile_useGetNewestBoardPostInfinite({
        request: {
            boardCategoryId: boardCategoryId,
            size: 20
        }
    }, {
        refetchOnWindowFocus: true,
        refetchInterval: 60 * 1000,
        select: function(data) {
            return {
                pages: (0,services_community/* newestBoardPostService */.Qh)(data.pages, !!boardCategoryId),
                pageParams: data.pageParams
            };
        }
    }), newestPostsData = ref.data, isNewestPostsLoading = ref.isLoading, hasNewestPostsNextPage = ref.hasNextPage, fetchNewestPostsNextPage = ref.fetchNextPage, newestPostsDataRefetch = ref.refetch;
    return {
        newestPostsData: newestPostsData,
        isNewestPostsLoading: isNewestPostsLoading,
        hasNewestPostsNextPage: hasNewestPostsNextPage,
        fetchNewestPostsNextPage: fetchNewestPostsNextPage,
        newestPostsDataRefetch: newestPostsDataRefetch
    };
};
/* harmony default export */ var community_useGetNewestBoardPost = (useGetNewestBoardPost);

// EXTERNAL MODULE: ./src/hooks/usePostReportModal.tsx + 3 modules
var usePostReportModal = __webpack_require__(53043);
// EXTERNAL MODULE: ./src/hooks/useReportModal.tsx
var useReportModal = __webpack_require__(51591);
// EXTERNAL MODULE: ./src/hooks/useToast.tsx
var useToast = __webpack_require__(17722);
;// CONCATENATED MODULE: ./src/hooks/community/useCommunityListViewModel.ts

















var useCommunityListViewModel = function(client) {
    var onOpenCommunityCloseNotice = board_useCommunityPopup(client).onOpenCommunityCloseNotice;
    var token = (0,es.useRecoilValue)(auth/* tokenState */.J1);
    var ref = (0,useCustomRouter/* default */.Z)(), moveToPage = ref.moveToPage, pageName = ref.pageName, _router = ref.router, query = _router.query, replace = _router.replace;
    var ref1 = (0,react.useState)(0), fixedBottomSheetWidth = ref1[0], setFixedBottomSheetWidth = ref1[1]; // WriteFixedBottomSheet
    var ref2 = (0,react.useState)(), selectedCategory = ref2[0], setSelectedCategory = ref2[1];
    var ref3 = (0,react.useState)(false), isVisibleBottomSheet = ref3[0], setIsVisibleBottomSheet = ref3[1];
    var showToast = (0,useToast/* default */.Z)().showToast;
    var setShowAuthModal = (0,useAuthModal/* default */.Z)().setShowAuthModal;
    var ref4 = (0,usePostReportModal/* default */.ZP)(), showReportModal = ref4.showReportModal, onShowReportModal = ref4.onShowReportModal, onCloseReportModal = ref4.onCloseReportModal, reportData = ref4.reportData, reportItems = ref4.reportItems;
    var categories = community_useGetBoardCategories().categories;
    var ref5 = community_useGetNewestBoardPost(selectedCategory === null || selectedCategory === void 0 ? void 0 : selectedCategory.boardCategoryId), newestPostsDataRefetch = ref5.newestPostsDataRefetch, isNewestPostsLoading = ref5.isNewestPostsLoading, hasNewestPostsNextPage = ref5.hasNewestPostsNextPage, fetchNewestPostsNextPage = ref5.fetchNewestPostsNextPage, newestPostsData = ref5.newestPostsData;
    var onToggleBottomSheet = function() {
        var on = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
        setIsVisibleBottomSheet(on);
    };
    var onClickCategory = function(category) {
        (0,logger/* mobileLogger */.Pp)({
            logger: {
                eventName: "comm_header_category_filter_click",
                pageName: pageName,
                payload: {
                    categoryId: category.boardCategoryId
                }
            }
        });
        setSelectedCategory(category);
        replace({
            query: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, query), {
                categoryId: category.boardCategoryId
            })
        }, undefined, {
            shallow: true
        });
        onToggleBottomSheet(false);
    };
    var onClickAllCategory = function() {
        (0,logger/* mobileLogger */.Pp)({
            logger: {
                eventName: "comm_header_category_filter_click",
                pageName: pageName,
                payload: {
                    categoryId: "all"
                }
            }
        });
        setSelectedCategory(undefined);
        replace({}, undefined, {
            shallow: true
        });
        onToggleBottomSheet(false);
    };
    var onClickSearchIcon = function() {
        var ref, ref1;
        moveToPage({
            webLink: "".concat(common/* ROUTES.COMMON.SEARCH.path */.Z6.COMMON.SEARCH.path, "?type=").concat(common/* BOARD_TYPE.COMMUNITY */.V_.COMMUNITY, "&categoryId=").concat(selectedCategory === null || selectedCategory === void 0 ? void 0 : selectedCategory.boardCategoryId, "&categoryName=").concat(selectedCategory === null || selectedCategory === void 0 ? void 0 : selectedCategory.name),
            mobileScreenName: common/* ROUTES.COMMON.SEARCH.appScreenName */.Z6.COMMON.SEARCH.appScreenName,
            params: {
                type: common/* BOARD_TYPE.COMMUNITY */.V_.COMMUNITY,
                categoryId: (ref = selectedCategory === null || selectedCategory === void 0 ? void 0 : selectedCategory.boardCategoryId) !== null && ref !== void 0 ? ref : "",
                categoryName: (ref1 = selectedCategory === null || selectedCategory === void 0 ? void 0 : selectedCategory.name) !== null && ref1 !== void 0 ? ref1 : ""
            }
        });
    };
    var onClickPost = function(e, post) {
        e.preventDefault();
        if (post.blinded) {
            return showToast({
                message: "신고로 인해 삭제 처리된 게시글입니다."
            });
        }
        (0,logger/* mobileLogger */.Pp)({
            logger: {
                eventName: "post_item_click",
                pageName: pageName,
                payload: {
                    id: post.boardPostPid
                }
            }
        });
        moveToPage({
            webLink: "".concat(common/* ROUTES.COMMUNITY.DETAIL.path */.Z6.COMMUNITY.DETAIL.path, "/").concat(post.boardPostPid),
            mobileScreenName: common/* ROUTES.COMMUNITY.DETAIL.appScreenName */.Z6.COMMUNITY.DETAIL.appScreenName,
            params: {
                id: post.boardPostPid
            }
        });
    };
    var onRefresh = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            newestPostsDataRefetch()
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function onRefresh() {
            return _ref.apply(this, arguments);
        };
    }();
    // 질문 신고하기
    var onClickReport = function(e, post) {
        e.preventDefault();
        e.stopPropagation();
        if (!token) {
            setShowAuthModal(true);
            return;
        }
        onShowReportModal({
            targetId: post.boardPostPid,
            targetType: useReportModal/* REPORT_TYPE.BOARD_POST */.Ry.BOARD_POST,
            isMine: post.isMine
        });
    };
    (0,react.useEffect)(function() {
        if (query.categoryId && categories) {
            var queryCategory = categories.filter(function(category) {
                return category.boardCategoryId === query.categoryId;
            })[0];
            setSelectedCategory(queryCategory);
        }
    }, [
        query,
        categories
    ]);
    (0,react.useEffect)(function() {
        var resize = function() {
            var ref;
            setFixedBottomSheetWidth(((ref = document.getElementById("postList")) === null || ref === void 0 ? void 0 : ref.clientWidth) || 0);
        };
        window.addEventListener("resize", resize);
        return function() {
            window.removeEventListener("resize", resize);
        };
    }, []);
    (0,react.useEffect)(function() {
        var ref;
        setFixedBottomSheetWidth(((ref = document.getElementById("postList")) === null || ref === void 0 ? void 0 : ref.clientWidth) || 0);
        onOpenCommunityCloseNotice();
    }, []);
    return {
        categories: categories,
        newestPostsDataRefetch: newestPostsDataRefetch,
        isNewestPostsLoading: isNewestPostsLoading,
        hasNewestPostsNextPage: hasNewestPostsNextPage,
        fetchNewestPostsNextPage: fetchNewestPostsNextPage,
        newestPostsData: newestPostsData,
        isVisibleBottomSheet: isVisibleBottomSheet,
        onClickCategory: onClickCategory,
        onToggleBottomSheet: onToggleBottomSheet,
        selectedCategory: selectedCategory,
        onClickSearchIcon: onClickSearchIcon,
        fixedBottomSheetWidth: fixedBottomSheetWidth,
        onClickAllCategory: onClickAllCategory,
        pageName: pageName,
        showReportModal: showReportModal,
        onCloseReportModal: onCloseReportModal,
        reportItems: reportItems,
        reportData: reportData,
        onRefresh: onRefresh,
        onClickPost: onClickPost,
        onClickReport: onClickReport
    };
};
/* harmony default export */ var community_useCommunityListViewModel = (useCommunityListViewModel);

// EXTERNAL MODULE: ./src/types/app.ts
var app = __webpack_require__(9912);
;// CONCATENATED MODULE: ./src/components/templates/mobile/communication/Community/CommunityListTemplate/index.tsx

function CommunityListTemplate_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  max-width: 768px;\n"
    ]);
    CommunityListTemplate_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CommunityListTemplate_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n"
    ]);
    CommunityListTemplate_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function CommunityListTemplate_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  height: 60px;\n  padding-left: 24px;\n  ",
        ";\n"
    ]);
    CommunityListTemplate_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function CommunityListTemplate_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  ",
        ";\n  color: ",
        ";\n  align-content: center;\n  justify-content: center;\n  padding: 0 12px;\n  height: 32px;\n  background: ",
        ";\n  margin-left: 16px;\n  border-radius: 8px;\n  & > svg {\n    margin-left: 8px;\n  }\n"
    ]);
    CommunityListTemplate_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
















var CommunityListTemplate = function(param) {
    var client = param.client;
    var ref, ref1, ref2, ref3, ref4;
    var viewModel = community_useCommunityListViewModel(client);
    var ref5, ref6;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TemplateLayout/* default.Wrapper */.Z.Wrapper, {
        children: [
            client.isWebView && /*#__PURE__*/ (0,jsx_runtime.jsx)(TemplateLayout/* default.Header */.Z.Header, {
                useSafeArea: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StickyAppHeader/* default */.Z, {
                    hasSearchButton: viewModel.onClickSearchIcon,
                    title: "커뮤니티"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TemplateLayout/* default.Content */.Z.Content, {
                children: [
                    client.clientType === app/* ClientType.WEB */.B.WEB && /*#__PURE__*/ (0,jsx_runtime.jsx)(BreadCrumbs/* default.Wrapper */.Z.Wrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BreadCrumbs/* default */.Z, {
                            visible: true,
                            path: "".concat(common/* ROUTES.COMMUNITY.LIST.path */.Z6.COMMUNITY.LIST.path),
                            type: "community",
                            name: (ref5 = (ref = viewModel.selectedCategory) === null || ref === void 0 ? void 0 : ref.name) !== null && ref5 !== void 0 ? ref5 : "전체",
                            urlParameter: (ref6 = "?categoryId=".concat((ref1 = viewModel.selectedCategory) === null || ref1 === void 0 ? void 0 : ref1.boardCategoryId)) !== null && ref6 !== void 0 ? ref6 : ""
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(CommunityListTemplate_Wrapper, {
                        id: "postList",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryWrapper, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Category, {
                                    children: [
                                        viewModel.selectedCategory ? viewModel.selectedCategory.name : "전체",
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(CategoryButton, {
                                            onClick: function() {
                                                return viewModel.onToggleBottomSheet();
                                            },
                                            type: "button",
                                            children: [
                                                "카테고리",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Arrow/* default */.Z, {
                                                    size: 12,
                                                    direction: common/* DIRECTION.TOP */.JR.TOP
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(PullToRefresh/* default */.Z, {
                                onRefresh: viewModel.onRefresh,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common_PostList, {
                                    posts: {
                                        data: (ref2 = viewModel.newestPostsData) === null || ref2 === void 0 ? void 0 : ref2.pages,
                                        isLoading: viewModel.isNewestPostsLoading,
                                        hasNextPage: viewModel.hasNewestPostsNextPage,
                                        fetchNextPage: function() {
                                            return viewModel.fetchNewestPostsNextPage();
                                        }
                                    },
                                    onClickReport: viewModel.onClickReport,
                                    onClickPost: viewModel.onClickPost
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CommunityCategoryBottomSheet/* default */.Z, {
                                isOpened: viewModel.isVisibleBottomSheet,
                                selectedCategoryId: (ref3 = viewModel.selectedCategory) === null || ref3 === void 0 ? void 0 : ref3.boardCategoryId,
                                onClickCategory: viewModel.onClickCategory,
                                onClose: function() {
                                    return viewModel.onToggleBottomSheet(false);
                                },
                                onClickAllCategory: viewModel.onClickAllCategory,
                                isFilter: true
                            }),
                            viewModel.reportItems && /*#__PURE__*/ (0,jsx_runtime.jsx)(ReportSelectModal/* default */.Z, {
                                isVisible: viewModel.showReportModal,
                                onClose: viewModel.onCloseReportModal,
                                selectList: viewModel.reportItems,
                                title: ((ref4 = viewModel.reportData) === null || ref4 === void 0 ? void 0 : ref4.isMine) ? "게시글 관리" : "신고하기"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(common_WriteFixedBottomSheet, {
                                pageName: viewModel.pageName,
                                selectedCategory: viewModel.selectedCategory,
                                width: viewModel.fixedBottomSheetWidth
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Community_CommunityListTemplate = (CommunityListTemplate);
var CommunityListTemplate_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-cb192216-0"
})(CommunityListTemplate_templateObject());
var CategoryWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-cb192216-1"
})(CommunityListTemplate_templateObject1());
var Category = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-cb192216-2"
})(CommunityListTemplate_templateObject2(), function(param) {
    var _$theme = param.theme;
    return _$theme.typography.UI22SB;
});
var CategoryButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-cb192216-3"
})(CommunityListTemplate_templateObject3(), function(param) {
    var _$theme = param.theme;
    return _$theme.typography.UI14M;
}, theme/* default.color.gray600 */.Z.color.gray600, theme/* default.color.gray50 */.Z.color.gray50);

;// CONCATENATED MODULE: ./src/pages/content/community/list/index.tsx
// PageDescription: 커뮤니티 리스트 페이지






var CommunityListPage = function(param) {
    var client = param.client;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
                title: "커뮤니티 - 닥터나우",
                canonical: "".concat("https://doctornow.co.kr").concat(common/* ROUTES.COMMUNITY.LIST.path */.Z6.COMMUNITY.LIST.path),
                description: "피부, 탈모, 육아 등 다양한 카테고리에서 나와 비슷한 고민을 가진 사람들을 만나보세요.",
                openGraph: {
                    url: "".concat("https://doctornow.co.kr").concat(common/* ROUTES.COMMUNITY.LIST.path */.Z6.COMMUNITY.LIST.path),
                    title: "커뮤니티 - 닥터나우",
                    description: "피부, 탈모, 육아 등 다양한 카테고리에서 나와 비슷한 고민을 가진 사람들을 만나보세요.",
                    images: [
                        {
                            url: "".concat("https://doctornow-front-images.s3.ap-northeast-2.amazonaws.com/og-community.png"),
                            alt: "Og Image Alt"
                        }, 
                    ]
                },
                twitter: {
                    handle: "@doctornow",
                    site: "@doctornow.co.kr",
                    cardType: "summary_large_image"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Community_CommunityListTemplate, {
                client: client
            })
        ]
    });
};
CommunityListPage.Layout = DefaultLayout/* default */.Z;
var __N_SSP = true;
/* harmony default export */ var list = (CommunityListPage);


/***/ }),

/***/ 75145:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "XL": function() { return /* binding */ parseCommunityUser; },
/* harmony export */   "j$": function() { return /* binding */ parseCommentsByComment; },
/* harmony export */   "kN": function() { return /* binding */ parseBoardCategories; }
/* harmony export */ });
/* unused harmony export parseMagazineRelatedBoardPost */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62230);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85244);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27484);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utils_format__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4611);




var parseBoardCategories = function(data) {
    return data.boardCategories;
};
var parseCommentsByComment = function(data) {
    return data.boardCommentBelongedBoardComments.map(function(comment) {
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, comment), {
            formattedCreatedAt: (0,_utils_format__WEBPACK_IMPORTED_MODULE_1__/* .displayedAt */ .hX)(comment.createdAt)
        });
    });
};
var parseCommunityUser = function(data) {
    var _bannedUntil;
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, data), {
        nickname: data.communityUser.nickname,
        userId: data.communityUser.userId,
        tutorialCompleted: data.communityUser.tutorialCompleted,
        profileImageUrl: data.communityUser.profileImageUrl,
        isAdmin: data.communityUser.isAdmin,
        bannedUntil: (_bannedUntil = data.communityUser.bannedUntil) !== null && _bannedUntil !== void 0 ? _bannedUntil : undefined,
        formattedBannedDate: data.communityUser.bannedUntil ? dayjs__WEBPACK_IMPORTED_MODULE_0___default()(data.communityUser.bannedUntil).format("YYYY년 MM월 DD일 HH시까지") : undefined,
        isBanned: dayjs__WEBPACK_IMPORTED_MODULE_0___default()().isBefore(data.communityUser.bannedUntil)
    });
};
var parseMagazineRelatedBoardPost = function(posts) {
    if (posts) {
        return posts.magazineRelatedBoardPosts.map(function(post) {
            return _object_spread_props(_object_spread({}, post), {
                boardPostAttachmentId: post.boardPostAttachments.filter(function(attachment) {
                    return attachment.blindType === "NONE";
                }).length > 0 ? post.boardPostAttachments.filter(function(attachment) {
                    return attachment.blindType === "NONE";
                })[0].boardPostAttachmentId : null
            });
        });
    }
    return [];
};


/***/ }),

/***/ 17454:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ closedCommunityPopupDayState; },
/* harmony export */   "y": function() { return /* binding */ closedHospitalPopupDayState; }
/* harmony export */ });
/* harmony import */ var recoil__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4480);
/* harmony import */ var _utils_atom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(80888);


var closedHospitalPopupDayState = (0,recoil__WEBPACK_IMPORTED_MODULE_0__.atom)({
    key: "closedHospitalPopupDay",
    default: null,
    effects: [
        (0,_utils_atom__WEBPACK_IMPORTED_MODULE_1__/* .localStorageEffect */ .N)("closedHospitalPopupDay")
    ]
});
var closedCommunityPopupDayState = (0,recoil__WEBPACK_IMPORTED_MODULE_0__.atom)({
    key: "closedCommunityPopupDay",
    default: null,
    effects: [
        (0,_utils_atom__WEBPACK_IMPORTED_MODULE_1__/* .localStorageEffect */ .N)("closedCommunityPopupDay")
    ]
});


/***/ }),

/***/ 30918:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FD": function() { return /* binding */ formatHour12Time; },
/* harmony export */   "Fo": function() { return /* binding */ isSameDate; },
/* harmony export */   "R5": function() { return /* binding */ getDayBeforeDate; },
/* harmony export */   "Ut": function() { return /* binding */ isBetweenDate; },
/* harmony export */   "Wv": function() { return /* binding */ formatDateTimeWithDash; },
/* harmony export */   "Z9": function() { return /* binding */ formatMonthWeekDateToKr; },
/* harmony export */   "_3": function() { return /* binding */ getDate; },
/* harmony export */   "_v": function() { return /* binding */ sleep; },
/* harmony export */   "cY": function() { return /* binding */ getBecomeDaysByTargetDate; },
/* harmony export */   "jn": function() { return /* binding */ formatDateTimeWithDot; },
/* harmony export */   "jq": function() { return /* binding */ formatYearMonthWeekDateToKr; },
/* harmony export */   "qw": function() { return /* binding */ getDayOfTheWeek; },
/* harmony export */   "wf": function() { return /* binding */ getDay; }
/* harmony export */ });
/* unused harmony exports formatYearMonthToKr, getNextYearDate */
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22386);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27484);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_0__);


var getBecomeDaysByTargetDate = function(targetDate, length) {
    return Array.from({
        length: length
    }, function(_, i) {
        var day = new Date(targetDate);
        day.setDate(day.getDate() + (i + 1));
        return day;
    });
};
var getDayBeforeDate = function(targetDate) {
    var yesterday = new Date(targetDate);
    yesterday.setDate(yesterday.getDate() - 1);
    return yesterday;
};
var formatDateTimeWithDash = function(date) {
    return new Intl.DateTimeFormat("fr-CA", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit"
    }).format(date);
};
var formatDateTimeWithDot = function(date) {
    return dayjs__WEBPACK_IMPORTED_MODULE_0___default()(date).format("YYYY.MM.DD");
};
var formatYearMonthToKr = function(date) {
    return new Intl.DateTimeFormat("ko-kr", {
        year: "numeric",
        month: "long"
    }).format(date);
};
var getNextYearDate = function(currentDate) {
    return new Date(currentDate.getFullYear() + 1, currentDate.getMonth(), currentDate.getDate());
};
var getDay = function(date) {
    return date.getDay();
};
var getDate = function(date) {
    return date.getDate();
};
var getDayOfTheWeek = function(day) {
    switch(day){
        case 0:
            return "일";
        case 1:
            return "월";
        case 2:
            return "화";
        case 3:
            return "수";
        case 4:
            return "목";
        case 5:
            return "금";
        case 6:
            return "토";
    }
};
var formatMonthWeekDateToKr = function(targetDate) {
    var date = new Date(targetDate);
    return new Intl.DateTimeFormat("ko-kr", {
        month: "long",
        day: "2-digit",
        weekday: "short"
    }).format(date);
};
var formatYearMonthWeekDateToKr = function(targetDate) {
    return dayjs__WEBPACK_IMPORTED_MODULE_0___default()(targetDate).format("YYYY.MM.DD(dd)");
};
var formatHour12Time = function(targetTime) {
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(targetTime.split(":"), 2), hour = ref[0], minute = ref[1];
    var formattedHour = parseInt(hour, 10);
    if (formattedHour === 0) {
        return "밤 12시 ".concat(minute, "분");
    } else if (formattedHour === 12) {
        return "낮 12시 ".concat(minute, "분");
    } else if (formattedHour > 12) {
        return "오후 ".concat(formattedHour - 12, "시 ").concat(minute, "분");
    } else {
        return "오전 ".concat(formattedHour, "시 ").concat(minute, "분");
    }
};
var isBetweenDate = function(param) {
    var startAt = param.startAt, endAt = param.endAt, unitType = param.unitType;
    return dayjs__WEBPACK_IMPORTED_MODULE_0___default()().isBetween(startAt, endAt, unitType, "[]");
};
var isSameDate = function(date, unitType) {
    return dayjs__WEBPACK_IMPORTED_MODULE_0___default()().isSame(date, unitType);
};
var sleep = function(ms) {
    return new Promise(function(resolve) {
        return setTimeout(resolve, ms);
    });
};


/***/ }),

/***/ 60288:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B4": function() { return /* binding */ setImageUrl; },
/* harmony export */   "Kp": function() { return /* binding */ resizingImg; },
/* harmony export */   "NR": function() { return /* binding */ convertedHeicSingleImage; },
/* harmony export */   "Or": function() { return /* binding */ isImage; },
/* harmony export */   "R2": function() { return /* binding */ redirectPostImage; },
/* harmony export */   "RW": function() { return /* binding */ convertHeic; },
/* harmony export */   "VM": function() { return /* binding */ onCompressImage; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22710);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62230);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22970);
/* harmony import */ var _utils_fetcher__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8391);
/* eslint-disable @typescript-eslint/no-var-requires */ 



var convertHeic = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(file) {
        var heic2any, blob, newImage;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        __webpack_require__.e(/* import() */ 4838).then(__webpack_require__.t.bind(__webpack_require__, 1616, 23))
                    ];
                case 1:
                    heic2any = _state.sent().default;
                    return [
                        4,
                        heic2any({
                            blob: file,
                            toType: "image/jpeg",
                            quality: 0.8
                        })
                    ];
                case 2:
                    blob = _state.sent();
                    newImage = new File([
                        blob
                    ], file.name.split(".")[0] + ".jpeg", {
                        type: "image/jpeg",
                        lastModified: new Date().getTime()
                    });
                    return [
                        2,
                        newImage
                    ];
            }
        });
    });
    return function convertHeic(file) {
        return _ref.apply(this, arguments);
    };
}();
var convertedHeicSingleImage = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(originFile) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!originFile.type.includes("heic")) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        convertHeic(originFile)
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
                case 2:
                    return [
                        2,
                        originFile
                    ];
            }
        });
    });
    return function convertedHeicSingleImage(originFile) {
        return _ref.apply(this, arguments);
    };
}();
var setImageUrl = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(file) {
        var convertedImage;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!file.type.includes("heic")) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        convertHeic(file)
                    ];
                case 1:
                    convertedImage = _state.sent();
                    return [
                        2,
                        Object.assign(convertedImage, {
                            blobUrl: URL.createObjectURL(convertedImage)
                        })
                    ];
                case 2:
                    return [
                        2,
                        Object.assign(file, {
                            blobUrl: URL.createObjectURL(file)
                        })
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function setImageUrl(file) {
        return _ref.apply(this, arguments);
    };
}();
var onCompressImage = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(file, options) {
        var imageCompression, blob, compressedImage;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        __webpack_require__.e(/* import() */ 221).then(__webpack_require__.bind(__webpack_require__, 40221))
                    ];
                case 1:
                    imageCompression = _state.sent().default;
                    return [
                        4,
                        imageCompression(file, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, options))
                    ];
                case 2:
                    blob = _state.sent();
                    compressedImage = new File([
                        blob
                    ], file.name.split(".")[0] + ".jpeg", {
                        type: "image/jpeg",
                        lastModified: new Date().getTime()
                    });
                    return [
                        2,
                        compressedImage
                    ];
            }
        });
    });
    return function onCompressImage(file, options) {
        return _ref.apply(this, arguments);
    };
}();
var resizingImg = function(param) {
    var originUrl = param.originUrl, width = param.width, height = param.height, _quality = param.quality, quality = _quality === void 0 ? 75 : _quality;
    return "".concat(originUrl, "?w=").concat(width, "&h=").concat(height, "&q=").concat(quality);
};
var isImage = function(image) {
    return image.type.includes("image");
};
var redirectPostImage = function(boardPostAttachmentId) {
    return "".concat(_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .BFF_BASE_URL */ .qG, "/api/v1/board/board-post-attachments/").concat(boardPostAttachmentId, "/redirect-to-signed-url");
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6577,7506,1433,4329,6562,9535,9004,2549,4654,3137,5839,9774,2888,179], function() { return __webpack_exec__(42872); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);